var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840,
    height: 880,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C277.2 0 554.4 0 840 0 C840 290.4 840 580.8 840 880 C562.8 880 285.6 880 0 880 C0 589.6 0 299.2 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C277.2 0 554.4 0 840 0 C840 290.4 840 580.8 840 880 C562.8 880 285.6 880 0 880 C0 589.6 0 299.2 0 0 Z M278.83984375 64.30859375 C268.94539862 75.91883862 264.16865935 90.35146289 258.96020508 104.45117188 C257.6668033 107.88445806 256.29844259 111.28550564 254.91796875 114.68457031 C253.95768612 117.10673002 253.0647695 119.54666612 252.1875 122 C248.41071487 132.47945912 244.47993071 142.93601268 239.83203125 153.0625 C238.63943448 155.83962675 237.71309519 158.68436129 236.80859375 161.56640625 C236.07150192 163.78480341 235.27338901 165.96481653 234.44946289 168.15209961 C234.17832169 168.87264023 233.90718048 169.59318085 233.62782288 170.33555603 C233.42064133 170.88482254 233.21345978 171.43408905 233 172 C231.96963057 172.00238835 230.93926113 172.00477671 229.87766838 172.00723743 C204.81485679 172.06601314 179.75214149 172.14188404 154.68943596 172.23571491 C142.56933333 172.28069428 130.44926023 172.32010404 118.32910156 172.34643555 C107.76606362 172.36939824 97.20311895 172.40277698 86.64015496 172.44870156 C81.0463428 172.47265701 75.45262314 172.4913706 69.85876083 172.49761391 C64.59417785 172.5036542 59.32983163 172.52361603 54.06533623 172.55427551 C52.13280442 172.56307264 50.20024169 172.56677486 48.26769066 172.56500816 C45.62894101 172.56335746 42.99091485 172.58003731 40.3522644 172.60127258 C39.58766085 172.59642501 38.82305729 172.59157743 38.03528392 172.58658296 C32.59204376 172.65886717 28.39192306 173.76715971 24.35546875 177.53515625 C21.43994101 181.34776945 19.88978384 183.45021609 19.79125977 188.21508789 C19.77196915 189.08682144 19.75267853 189.95855499 19.73280334 190.85670471 C19.67490163 194.86528339 19.62572942 198.87368209 19.5949707 202.88256836 C19.57344983 204.99015752 19.53941783 207.09765874 19.49243164 209.20483398 C19.42510273 212.25284514 19.39791252 215.29900417 19.37890625 218.34765625 C19.35107559 219.27925064 19.32324493 220.21084503 19.29457092 221.17066956 C19.31602092 228.08072132 21.22476906 232.91724046 26 238 C29.86500365 240.71892287 34.18891954 240.2664022 38.71582031 240.22705078 C40.0334285 240.22748886 40.0334285 240.22748886 41.37765503 240.22793579 C44.27791255 240.22654367 47.17791242 240.21098794 50.078125 240.1953125 C52.09022888 240.19158195 54.10233457 240.18873518 56.11444092 240.18673706 C61.40809146 240.1791039 66.70163211 240.15945807 71.99523926 240.1373291 C77.39785272 240.11686389 82.80048395 240.10773389 88.203125 240.09765625 C98.80213159 240.07621193 109.40105666 240.04207975 120 240 C119.99829126 241.65257365 119.99829126 241.65257365 119.996548 243.33853263 C119.94653016 291.90340082 119.90024836 340.46827063 119.87297058 389.03315735 C119.87255641 389.76865534 119.87214224 390.50415333 119.87171552 391.26193914 C119.86273634 407.24711846 119.85442586 423.23229806 119.84680401 439.21747808 C119.84306207 447.05685068 119.8391724 454.89622321 119.83520508 462.7355957 C119.83461666 463.90574999 119.83461666 463.90574999 119.83401636 465.09954377 C119.82123723 490.37513374 119.79870696 515.65070357 119.77110834 540.92628135 C119.74279366 566.90488143 119.72433975 592.88347038 119.71825503 618.86208563 C119.71739059 622.53319254 119.71641368 626.20429941 119.71536827 629.87540627 C119.715166 630.59791747 119.71496373 631.32042867 119.71475533 632.06483415 C119.71121315 643.68519706 119.69730698 655.30552546 119.6795039 666.92587431 C119.66181838 678.61435344 119.65534451 690.30278999 119.65949587 701.9912829 C119.6614178 708.32189108 119.65846615 714.65239814 119.64238358 720.98298836 C119.62775833 726.7823309 119.62706483 732.58150454 119.63730332 738.38085494 C119.63856828 740.47528843 119.63478516 742.56973257 119.62535045 744.66414519 C119.56502304 758.88697293 120.58089243 771.37710549 126.25 784.625 C126.55518555 785.34518311 126.86037109 786.06536621 127.17480469 786.80737305 C132.16633761 798.26404406 139.29928154 807.16598362 148 816 C148.78117188 816.80566406 149.56234375 817.61132812 150.3671875 818.44140625 C168.95737114 836.43695439 192.29667791 840.3163762 217.17752075 840.26742554 C218.99423818 840.27116821 220.810954 840.27577218 222.62766731 840.28115618 C227.58972683 840.29332525 232.55171863 840.29313294 237.51378965 840.29076743 C242.87731165 840.29035772 248.24081237 840.30141312 253.60432434 840.31088257 C264.10126223 840.32746002 274.59817765 840.33299064 285.09512754 840.33410732 C293.63203401 840.33505933 302.16893311 840.33917726 310.70583725 840.34550858 C334.9366375 840.36311203 359.16742006 840.37234884 383.39822675 840.37084763 C384.70314982 840.37076772 386.00807288 840.3706878 387.35253906 840.37060547 C389.31232761 840.37048283 389.31232761 840.37048283 391.31170784 840.37035771 C412.47918363 840.36954504 433.64658822 840.38868021 454.81404342 840.4168822 C476.57520059 840.44564526 498.33632307 840.45942062 520.09749973 840.45769465 C532.30405554 840.45703194 544.51053671 840.46247218 556.71707535 840.48405075 C567.11075779 840.50230758 577.50433174 840.50657296 587.89802332 840.4930319 C593.19459039 840.48652501 598.49094958 840.48630232 603.78749657 840.5037384 C608.64854275 840.51957538 613.50921809 840.51649818 618.37025581 840.49917014 C620.11649422 840.49612347 621.86276105 840.49964312 623.60896589 840.51089029 C651.36030924 840.67760869 674.88118633 832.81191651 695 813 C705.03899785 802.97952429 711.4440033 791.35617283 716 778 C716.30808594 777.14019531 716.61617187 776.28039062 716.93359375 775.39453125 C719.43362297 768.25329946 720.14707201 761.62304845 720.12304783 754.0938282 C720.1247786 752.75891445 720.1247786 752.75891445 720.12654433 751.39703274 C720.12919767 748.4057932 720.12469934 745.41460716 720.12025452 742.42337036 C720.12069048 740.26092131 720.12156585 738.09847231 720.12284368 735.93602359 C720.1250837 729.98654987 720.12107405 724.03709408 720.11606562 718.08762264 C720.11175427 711.67458026 720.11320803 705.26153891 720.1139679 698.84849548 C720.11449269 687.73504517 720.11138533 676.62160082 720.10573006 665.50815201 C720.09981379 653.85195005 720.09596426 642.19575042 720.09487724 630.53954697 C720.0948085 629.81490004 720.09473976 629.09025311 720.09466894 628.34364718 C720.09433061 624.66355745 720.09402923 620.98346771 720.09374207 617.30337797 C720.09164145 591.23480247 720.08490351 565.16623003 720.07543945 539.09765625 C720.06625565 513.77181006 720.05917173 488.44596471 720.05493164 463.12011719 C720.05480011 462.3395151 720.05466859 461.55891302 720.05453308 460.75465632 C720.05321456 452.91555589 720.05193875 445.07645545 720.05069422 437.237355 C720.04815798 421.26808973 720.04533673 405.29882452 720.04234314 389.32955933 C720.0421372 388.22818888 720.0421372 388.22818888 720.04192711 387.10456852 C720.03272587 338.06971105 720.01685981 289.03485537 720 240 C721.0994545 240.00888245 722.198909 240.01776489 723.3316803 240.0269165 C733.70432378 240.10808203 744.07690264 240.16800373 754.44979191 240.20724869 C759.78233664 240.2281034 765.11462455 240.25638267 770.44702148 240.30175781 C775.59526016 240.34529062 780.74325213 240.36915302 785.89166069 240.37950897 C787.85363077 240.38688697 789.8155877 240.40129454 791.77745247 240.42292023 C794.53039617 240.45205297 797.28232679 240.45595188 800.03540039 240.45410156 C801.24597359 240.47567322 801.24597359 240.47567322 802.48100281 240.49768066 C808.11119176 240.45686432 811.3704356 239.24475299 816 236 C820.34596979 230.3870441 820.59178086 225.6313539 820.53125 218.68359375 C820.5350769 217.7089064 820.53890381 216.73421906 820.54284668 215.72999573 C820.54555772 213.6784664 820.53825338 211.62690203 820.52148438 209.57543945 C820.50004031 206.44338723 820.52132585 203.31362264 820.546875 200.18164062 C820.54423203 198.18228663 820.5391077 196.18293405 820.53125 194.18359375 C820.54339539 192.78650429 820.54339539 192.78650429 820.55578613 191.3611908 C820.47540717 185.76474098 819.94646899 182.28120017 816 178 C810.57253506 173.70960795 806.21783493 172.26794454 799.3692627 172.39872742 C798.12169323 172.39231923 798.12169323 172.39231923 796.84892035 172.38578159 C794.08166259 172.377592 791.31594453 172.40496871 788.54882812 172.43237305 C786.557526 172.43378439 784.56622127 172.43298985 782.57492065 172.43016052 C777.18277511 172.42872835 771.79118785 172.45808629 766.39917183 172.49303031 C760.7591041 172.52432678 755.119023 172.52722716 749.47888184 172.53315735 C738.80465254 172.54868607 728.13067987 172.58970159 717.45656347 172.6399048 C705.30186918 172.69582833 693.14716252 172.72329237 680.99237156 172.74838197 C655.99477221 172.80061813 630.99740049 172.88854173 606 173 C605.87882813 172.31292969 605.75765625 171.62585938 605.6328125 170.91796875 C605.38144531 169.56638672 605.38144531 169.56638672 605.125 168.1875 C604.96257813 167.29417969 604.80015625 166.40085937 604.6328125 165.48046875 C604.08811551 162.77272154 604.08811551 162.77272154 602 160 C601.31367192 157.97533217 600.63268925 155.94871818 599.9765625 153.9140625 C597.17612808 145.55756618 594.01332573 137.29637103 590.5625 129.1875 C587.69733671 122.42534613 585.21820811 115.52906205 582.69921875 108.6328125 C580.88920028 103.68131424 579.02170539 98.75526915 577.10546875 93.84375 C576.40343747 92.03781793 575.71667677 90.22581635 575.05078125 88.40625 C567.89503904 69.32427078 555.12810964 54.96702412 536.72265625 46.12890625 C531.61265535 44.01012539 526.32685292 42.47246341 521 41 C520.44005624 40.82132228 519.88011248 40.64264456 519.30320072 40.45855236 C515.96677736 39.79429206 512.65353831 39.85911861 509.26597595 39.86628723 C508.09030283 39.8628889 508.09030283 39.8628889 506.89087874 39.85942191 C504.26179159 39.85308668 501.63275605 39.85391099 499.00366211 39.85473633 C497.11946547 39.85174442 495.23526944 39.84834182 493.35107422 39.84455872 C488.22883176 39.83571482 483.106606 39.83338036 477.98435664 39.83274293 C474.78213181 39.83203231 471.57991123 39.82989771 468.37768745 39.82724571 C457.19978694 39.81798898 446.02189836 39.81391098 434.84399414 39.81469727 C424.43652969 39.81529722 414.02911721 39.80476238 403.62166589 39.7889536 C394.67965894 39.77585657 385.73766892 39.77051432 376.79565245 39.77115268 C371.4582773 39.77140715 366.12094826 39.76858417 360.78358269 39.75797462 C355.75785612 39.74825799 350.73221939 39.74823886 345.70648956 39.75549126 C343.86795228 39.75653288 342.02940929 39.75419947 340.19088173 39.7481308 C315.49143041 39.67192397 296.15639126 45.80212074 278.83984375 64.30859375 Z ",
    fill: "#EFEFEF",
    transform: "translate(0,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.78508308 -0.00367669 1.57016617 -0.00735338 2.37903965 -0.01114148 C4.98869237 -0.0220839 7.59830516 -0.02600594 10.20797729 -0.02983093 C12.08789697 -0.03610268 13.96781542 -0.0427501 15.84773254 -0.04974365 C22.00279898 -0.07070031 28.15786542 -0.08113759 34.31295776 -0.09111023 C36.43868904 -0.0951608 38.56442019 -0.09927781 40.69015121 -0.10346031 C50.67902452 -0.12249286 60.66789052 -0.13672842 70.65677845 -0.14507228 C82.15804817 -0.15484027 93.65912521 -0.18115662 105.16032708 -0.22157317 C114.0701892 -0.25180118 122.97999629 -0.26654745 131.88990867 -0.26985329 C137.20223748 -0.27219591 142.51436 -0.28105366 147.82663345 -0.30631447 C152.82869092 -0.32971781 157.830408 -0.33377942 162.83250618 -0.32355309 C164.65850906 -0.3230606 166.48452942 -0.32929517 168.31048012 -0.34310913 C190.67201941 -0.50268841 209.70182094 6.16080085 226.31295776 21.52998352 C232.56157856 28.09201477 237.68324352 35.61794328 240.72311401 44.18232727 C241.90830359 47.42983229 243.25595734 50.58117512 244.62374878 53.75508118 C247.92315866 61.42142435 250.9419658 69.12191959 253.65841675 77.01264954 C256.65661338 85.69452538 260.15601181 94.16680076 263.66842651 102.65107727 C263.9823938 103.41033508 264.29636108 104.1695929 264.61984253 104.95185852 C265.22599254 106.41509927 265.83441315 107.87740231 266.44552612 109.33857727 C268.06354734 113.23268676 269.51441857 117.12908272 270.80514526 121.14717102 C271.08616089 121.95541321 271.36717651 122.7636554 271.65670776 123.59638977 C272.03955933 124.70433899 272.03955933 124.70433899 272.43014526 125.83467102 C272.69053589 126.58103821 272.95092651 127.3274054 273.21920776 128.09638977 C273.80514526 130.14717102 273.80514526 130.14717102 273.80514526 133.14717102 C274.83882484 133.14256206 275.87250443 133.13795309 276.93750763 133.13320446 C302.09269673 133.02219184 327.24785404 132.94003524 352.40323639 132.88811016 C364.56821907 132.86233194 376.7330399 132.82718842 388.8979187 132.76997375 C399.50120702 132.72012745 410.10437813 132.68787724 420.70778036 132.67672855 C426.32191065 132.67021195 431.93570561 132.65490351 437.54972839 132.61852074 C442.83567438 132.5845422 448.1211474 132.57412197 453.40719223 132.58163261 C455.34537706 132.58025892 457.28357797 132.57033766 459.22166824 132.55114365 C461.87315824 132.52617608 464.52287485 132.53227874 467.17440796 132.54589844 C468.3184112 132.52405213 468.3184112 132.52405213 469.48552561 132.50176448 C475.33273133 132.58266001 479.24029238 134.53867078 483.80514526 138.14717102 C488.4525934 143.18880592 488.39308494 147.80972459 488.33639526 154.33076477 C488.34022217 155.30449539 488.34404907 156.27822601 488.34799194 157.28146362 C488.35070623 159.33477313 488.34337897 161.38811749 488.32662964 163.44136047 C488.30523664 166.57130183 488.32643617 169.69894183 488.35202026 172.82881165 C488.34937645 174.82946772 488.34425036 176.83012237 488.33639526 178.83076477 C488.34449219 179.76013351 488.35258911 180.68950226 488.3609314 181.64703369 C488.27490266 187.65836025 487.52647005 191.34096368 483.80514526 196.14717102 C478.34143758 199.97655546 474.42188634 200.71854795 467.84054565 200.60127258 C466.53691071 200.60214874 466.53691071 200.60214874 465.2069397 200.6030426 C462.35514363 200.60027208 459.50441333 200.56922942 456.65280151 200.53779602 C454.66740998 200.53032995 452.68201105 200.52463875 450.6966095 200.52064514 C445.48668858 200.50541767 440.27721808 200.46616067 435.06747437 200.42182922 C429.74506726 200.38081422 424.42258694 200.36262083 419.10006714 200.34248352 C408.66822929 200.29966368 398.23672482 200.23144731 387.80514526 200.14717102 C387.8059047 201.25078539 387.80666414 202.35439976 387.8074466 203.49145699 C387.84078174 252.12498304 387.87163768 300.75850981 387.88983154 349.39204407 C387.89010766 350.12823235 387.89038377 350.86442062 387.89066825 351.62291764 C387.89665395 367.62193686 387.90219433 383.62095621 387.90727592 399.61997575 C387.90977061 407.46579217 387.91236372 415.31160855 387.91500854 423.15742493 C387.91527006 423.93818158 387.91553158 424.71893824 387.91580102 425.52335419 C387.92432504 450.83388706 387.93934865 476.14441101 387.95773971 501.45493847 C387.97660323 527.46290225 387.98891577 553.4708611 387.99297524 579.4788316 C387.99355156 583.15154225 387.99420283 586.82425288 387.99489975 590.4969635 C387.9950346 591.21981182 387.99516944 591.94266014 387.99530837 592.68741295 C387.99767261 604.32735096 388.00695089 615.96727371 388.01880933 627.6072055 C388.0305812 639.30679487 388.03491986 651.00636534 388.03214802 662.70596081 C388.03086416 669.04605371 388.03286369 675.38610178 388.04355621 681.72618675 C388.05327024 687.52832188 388.05379215 693.33038189 388.04694305 699.13252044 C388.04609622 701.23359251 388.04864887 703.33466922 388.05491163 705.43573213 C388.06292292 708.2888814 388.05862021 711.14175856 388.05124092 713.99490356 C388.05649495 714.81296012 388.06174898 715.63101668 388.06716222 716.47386283 C388.03664143 721.68667865 387.23812591 726.13088566 385.80514526 731.14717102 C385.41455933 732.66310852 385.41455933 732.66310852 385.01608276 734.20967102 C381.02117255 748.24786017 374.74355114 760.40202063 364.80514526 771.14717102 C364.13096558 771.91287415 363.45678589 772.67857727 362.76217651 773.46748352 C354.30415941 782.57611733 343.75059893 789.23079779 332.36764526 794.08467102 C331.74953979 794.35489075 331.13143433 794.62511047 330.49459839 794.90351868 C317.26091435 800.17495841 303.26629114 800.58693116 289.24667358 800.52812195 C287.42522798 800.53158655 285.60378448 800.53635647 283.78234529 800.54230368 C278.82123252 800.55473308 273.86029469 800.54868034 268.8991816 800.53934503 C263.53167856 800.53252157 258.16420436 800.54305202 252.79670715 800.55128479 C242.29916471 800.56458929 231.8016868 800.56175904 221.30414188 800.55304687 C212.76870946 800.54625778 204.23329506 800.54535889 195.69786072 800.54861832 C194.48071382 800.54907802 193.26356691 800.54953771 192.00953677 800.55001134 C189.53653601 800.55097057 187.06353526 800.55194321 184.59053451 800.55292912 C161.42870263 800.5614734 138.26690645 800.55166399 115.10508043 800.53552802 C95.25296829 800.52212572 75.40090879 800.52445409 55.54879761 800.5382843 C32.46697928 800.55435712 9.38519219 800.56064951 -13.69663095 800.55144751 C-16.16027736 800.55049191 -18.62392377 800.5495488 -21.08757019 800.54861832 C-22.29957162 800.54815549 -23.51157305 800.54769266 -24.7603018 800.54721581 C-33.28048087 800.54463103 -41.80064005 800.54898587 -50.32081604 800.55605698 C-60.71120985 800.56449109 -71.10153571 800.56215171 -81.49192178 800.54621474 C-86.78810003 800.53835774 -92.0841652 800.5351964 -97.38034248 800.5451622 C-102.23736346 800.55416308 -107.09416751 800.54908823 -111.95116907 800.53322954 C-113.6992794 800.52990443 -115.44740841 800.53152402 -117.19550651 800.53885691 C-143.57340879 800.6409368 -166.12104812 794.01175855 -185.19485474 775.14717102 C-185.82778442 774.56322571 -186.46071411 773.9792804 -187.11282349 773.37763977 C-200.43021918 760.82459791 -211.42802094 739.62687514 -212.28605575 721.18720819 C-212.32178803 718.87123359 -212.32529322 716.55724196 -212.31790257 714.24099922 C-212.31905641 713.35105672 -212.32021025 712.46111422 -212.32139906 711.54420376 C-212.32405241 708.55296422 -212.31955408 705.56177818 -212.31510925 702.57054138 C-212.31554522 700.40809233 -212.31642059 698.24564333 -212.31769842 696.08319461 C-212.31993844 690.13372089 -212.31592879 684.1842651 -212.31092036 678.23479366 C-212.30660901 671.82175128 -212.30806277 665.40870993 -212.30882263 658.9956665 C-212.30934743 647.88221619 -212.30624007 636.76877184 -212.30058479 625.65532303 C-212.29466852 613.99912107 -212.290819 602.34292144 -212.28973198 590.68671799 C-212.28966324 589.96207106 -212.2895945 589.23742413 -212.28952368 588.49081821 C-212.28918535 584.81072847 -212.28888396 581.13063873 -212.2885968 577.45054899 C-212.28649618 551.38197349 -212.27975825 525.31340105 -212.27029419 499.24482727 C-212.26111039 473.91898108 -212.25402646 448.59313573 -212.24978638 423.26728821 C-212.24965485 422.48668612 -212.24952332 421.70608404 -212.24938781 420.90182734 C-212.2480693 413.06272691 -212.24679348 405.22362647 -212.24554895 397.38452602 C-212.24301271 381.41526075 -212.24019146 365.44599554 -212.23719788 349.47673035 C-212.23699194 348.3753599 -212.23699194 348.3753599 -212.23678185 347.25173954 C-212.22758061 298.21688207 -212.21171455 249.18202639 -212.19485474 200.14717102 C-213.30905792 200.15605347 -214.42326111 200.16493591 -215.57122803 200.17408752 C-226.07662922 200.25520922 -236.58196678 200.31515373 -247.08761024 200.35441971 C-252.48856292 200.3752855 -257.88926254 200.40358509 -263.29006958 200.44892883 C-268.50314188 200.49242201 -273.71597091 200.51631571 -278.92921066 200.52667999 C-280.9171265 200.53406509 -282.90502918 200.54848651 -284.89284134 200.57009125 C-287.67951371 200.5991712 -290.4651837 200.60312508 -293.25198364 200.60127258 C-294.07197845 200.61565369 -294.89197327 200.63003479 -295.73681641 200.64485168 C-301.02110785 200.60689521 -304.00681356 199.65258396 -308.19485474 196.14717102 C-312.47640056 190.46983769 -312.78687357 185.80583976 -312.72610474 178.83076477 C-312.72993164 177.85607742 -312.73375854 176.88139008 -312.73770142 175.87716675 C-312.74041246 173.82563742 -312.73310812 171.77407305 -312.71633911 169.72261047 C-312.69489504 166.59055825 -312.71618059 163.46079366 -312.74172974 160.32881165 C-312.73908677 158.32945765 -312.73396244 156.33010507 -312.72610474 154.33076477 C-312.73420166 153.3993718 -312.74229858 152.46797882 -312.75064087 151.50836182 C-312.66985688 145.88371232 -311.96800087 142.59638248 -308.19485474 138.14717102 C-302.98215725 133.44302939 -299.00809464 132.99755913 -292.20335388 132.98895264 C-291.37999658 132.98401466 -290.55663928 132.97907668 -289.70833176 132.97398907 C-286.93992548 132.95858893 -284.17154243 132.95024663 -281.40310669 132.94184875 C-279.42239171 132.93227221 -277.44167878 132.92226226 -275.46096802 132.91184998 C-270.07496691 132.88477064 -264.68895702 132.86377747 -259.30292535 132.84384799 C-253.67746385 132.82200712 -248.05202954 132.79460915 -242.42658997 132.76779175 C-231.77004017 132.71783916 -221.11347531 132.67290985 -210.45689601 132.62976938 C-198.32644677 132.58041893 -186.19602481 132.52549268 -174.06560194 132.47008979 C-149.10871165 132.35623035 -124.15179519 132.24939994 -99.19485474 132.14717102 C-98.39220643 130.2434161 -97.59187511 128.33868421 -96.79251099 126.43354797 C-96.34657593 125.3729567 -95.90064087 124.31236542 -95.44119263 123.21963501 C-94.12758657 119.98134198 -93.00416638 116.72365682 -91.93704224 113.39863586 C-90.49831305 109.03417517 -88.83205322 104.75270088 -87.19485474 100.45967102 C-86.85196411 99.54894836 -86.50907349 98.63822571 -86.15579224 97.6999054 C-84.38299175 93.04122931 -82.46900117 88.58875907 -80.19485474 84.14717102 C-79.72145112 82.84718967 -79.28064518 81.53459638 -78.88235474 80.20967102 C-77.34803521 75.43090499 -75.48745692 70.80185348 -73.59793091 66.15596008 C-71.96720142 62.12880198 -70.4228612 58.08088395 -68.93875122 53.99751282 C-64.5995929 42.11075386 -59.68157699 31.69889371 -51.19485474 22.14717102 C-50.64055786 21.51037415 -50.08626099 20.87357727 -49.51516724 20.21748352 C-42.58440037 12.75613163 -33.57648875 7.86866791 -24.19485474 4.14717102 C-23.17778442 3.71597961 -23.17778442 3.71597961 -22.14016724 3.27607727 C-14.95174821 0.35315981 -7.70187351 -0.00197735 0 0 Z M-145.19485474 200.14717102 C-145.36707899 288.62027464 -145.36707899 288.62027464 -145.48384452 377.09340942 C-145.49609164 389.9075001 -145.50861911 402.72159046 -145.5220107 415.53568 C-145.52362975 417.08562268 -145.52523998 418.63556537 -145.52684127 420.18550806 C-145.55243735 444.88993968 -145.59745625 469.59428884 -145.65263806 494.29867063 C-145.70925387 519.69119274 -145.74617209 545.08366927 -145.75834468 570.47625343 C-145.76007358 574.06367435 -145.7620274 577.65109512 -145.76411819 581.23851585 C-145.76452273 581.9445641 -145.76492727 582.65061234 -145.76534407 583.37805598 C-145.77243137 594.7385106 -145.80025151 606.09882416 -145.83584694 617.45922128 C-145.87119873 628.88332529 -145.88417024 640.30724732 -145.875863 651.73141918 C-145.87201637 657.92013355 -145.87795265 664.10843427 -145.91008759 670.29707527 C-145.93930112 675.96448249 -145.94075026 681.6311982 -145.92024811 687.29863735 C-145.91771448 689.34728566 -145.92531335 691.39597724 -145.94415383 693.44454048 C-146.053571 706.07776215 -145.33094278 714.80916882 -136.92141724 724.86592102 C-136.22790161 725.45373352 -135.53438599 726.04154602 -134.81985474 726.64717102 C-134.13149536 727.25560852 -133.44313599 727.86404602 -132.73391724 728.49092102 C-124.09780691 734.12432222 -115.28585739 733.57113404 -105.37979126 733.52812195 C-103.650294 733.53158035 -101.92079895 733.53634614 -100.1913085 733.54230368 C-95.44750861 733.55481826 -90.70388996 733.54864117 -85.96008945 733.53934503 C-80.84072569 733.53255678 -75.72139309 733.54303466 -70.60203552 733.55128479 C-60.57665467 733.56462669 -50.5513412 733.56174233 -40.5259577 733.55304687 C-32.37832755 733.54627254 -24.23071627 733.54535252 -16.08308411 733.54861832 C-14.92360145 733.54907802 -13.76411879 733.54953771 -12.5695003 733.55001134 C-10.21405541 733.55097052 -7.85861054 733.55194316 -5.50316566 733.55292912 C16.58537985 733.56148435 38.67388801 733.55164678 60.76242739 733.53552802 C79.71662679 733.52212473 98.67077107 733.52445278 117.62496948 733.5382843 C139.63431948 733.55433774 161.64363674 733.56066037 183.65299177 733.55144751 C185.99978605 733.55049186 188.34658034 733.54954875 190.69337463 733.54861832 C191.84805124 733.54815549 193.00272784 733.54769266 194.19239464 733.54721581 C202.33051616 733.54462522 210.46861692 733.54899842 218.60673523 733.55605698 C228.5239774 733.56446954 238.44114834 733.56219692 248.35838234 733.54621474 C253.41858474 733.5383288 258.47866834 733.53524602 263.53886986 733.5451622 C268.17127783 733.55410279 272.80345691 733.54918665 277.43584412 733.53322954 C279.11137325 733.52987906 280.78692172 733.53158182 282.4624384 733.53885691 C294.34043793 733.58647395 303.7921329 732.76912293 312.80514526 724.14717102 C318.57873128 716.90464166 321.11199241 710.87609944 321.05124092 701.56707287 C321.05470245 700.26681317 321.05470245 700.26681317 321.05823392 698.94028559 C321.06354807 696.0215559 321.05453801 693.1030447 321.0456543 690.18432617 C321.04652607 688.07636218 321.04827654 685.9683984 321.05083263 683.86043578 C321.05531564 678.05690229 321.04728936 672.25344228 321.03727651 666.44991815 C321.02865804 660.1956872 321.03156103 653.94146056 321.03308105 647.68722534 C321.03413092 636.84767126 321.02791335 626.0081468 321.01660538 615.16860008 C321.00477487 603.79905267 320.9970742 592.42951484 320.99489975 581.05996132 C320.99476227 580.35326816 320.99462479 579.646575 320.99448315 578.9184669 C320.99380649 575.32958879 320.99320372 571.74071068 320.99262939 568.15183256 C320.9884276 542.72603716 320.97495015 517.30025429 320.95602417 491.87446594 C320.93765805 467.17231817 320.92352329 442.47017384 320.91500854 417.76802063 C320.91446726 416.2149029 320.91392585 414.66178517 320.91338432 413.10866743 C320.90900683 400.48911269 320.90492165 387.86955786 320.90090735 375.250003 C320.88212972 316.88238048 320.84198963 258.51479062 320.80514526 200.14717102 C167.02514526 200.14717102 13.24514526 200.14717102 -145.19485474 200.14717102 Z ",
    fill: "#010101",
    transform: "translate(332.1948547363281,39.85282897949219)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.89 0 21.78 0 33 0 C33 6.6 33 13.2 33 20 C39.6 20 46.2 20 53 20 C53 13.73 53 7.46 53 1 C72.8 1 92.6 1 113 1 C113 7.27 113 13.54 113 20 C119.6 20 126.2 20 133 20 C133 13.73 133 7.46 133 1 C152.8 1 172.6 1 193 1 C193 7.27 193 13.54 193 20 C199.6 20 206.2 20 213 20 C213 13.73 213 7.46 213 1 C232.8 1 252.6 1 273 1 C273 7.27 273 13.54 273 20 C279.6 20 286.2 20 293 20 C293 13.73 293 7.46 293 1 C312.8 1 332.6 1 353 1 C353 7.27 353 13.54 353 20 C359.6 20 366.2 20 373 20 C373 13.73 373 7.46 373 1 C392.8 1 412.6 1 433 1 C433 7.27 433 13.54 433 20 C439.6 20 446.2 20 453 20 C453 26.6 453 33.2 453 40 C446.4 40 439.8 40 433 40 C433 46.6 433 53.2 433 60 C439.6 60 446.2 60 453 60 C453 66.6 453 73.2 453 80 C446.4 80 439.8 80 433 80 C433 86.6 433 93.2 433 100 C439.6 100 446.2 100 453 100 C453 106.6 453 113.2 453 120 C446.4 120 439.8 120 433 120 C433 126.6 433 133.2 433 140 C439.6 140 446.2 140 453 140 C453 146.6 453 153.2 453 160 C446.4 160 439.8 160 433 160 C433 166.6 433 173.2 433 180 C439.6 180 446.2 180 453 180 C453 186.6 453 193.2 453 200 C446.4 200 439.8 200 433 200 C433 206.6 433 213.2 433 220 C439.6 220 446.2 220 453 220 C453 226.6 453 233.2 453 240 C446.4 240 439.8 240 433 240 C433 246.6 433 253.2 433 260 C439.6 260 446.2 260 453 260 C453 266.6 453 273.2 453 280 C446.4 280 439.8 280 433 280 C433 286.6 433 293.2 433 300 C439.6 300 446.2 300 453 300 C453 306.6 453 313.2 453 320 C446.4 320 439.8 320 433 320 C433 326.6 433 333.2 433 340 C439.6 340 446.2 340 453 340 C453 346.6 453 353.2 453 360 C446.4 360 439.8 360 433 360 C433 366.6 433 373.2 433 380 C439.6 380 446.2 380 453 380 C453 386.6 453 393.2 453 400 C446.4 400 439.8 400 433 400 C433 406.6 433 413.2 433 420 C439.6 420 446.2 420 453 420 C453 426.6 453 433.2 453 440 C446.4 440 439.8 440 433 440 C433 446.6 433 453.2 433 460 C439.6 460 446.2 460 453 460 C453 466.6 453 473.2 453 480 C446.4 480 439.8 480 433 480 C433 486.6 433 493.2 433 500 C426.4 500 419.8 500 413 500 C413 493.4 413 486.8 413 480 C406.73 480 400.46 480 394 480 C396 476 396 476 397.6012302 473.67783922 C399.36118759 470.30853361 399.37708938 467.94899168 399.38031673 464.15457249 C399.38730661 463.13559081 399.38730661 463.13559081 399.3944377 462.09602365 C399.40640826 459.8150048 399.39698471 457.53457934 399.38768005 455.2535553 C399.39185208 453.60359234 399.39732887 451.95363225 399.40399987 450.3036775 C399.41849044 445.76587143 399.41419851 441.22824642 399.40683305 436.69043028 C399.40211261 431.79804301 399.41460125 426.90569554 399.42485046 422.01332092 C399.44206578 412.42736186 399.44287283 402.84146827 399.43763756 393.25549776 C399.43359978 385.4658058 399.43503475 377.67613322 399.44038582 369.88644218 C399.44113424 368.77870748 399.44188266 367.67097277 399.44265376 366.52967034 C399.4441852 364.27947239 399.44572355 362.02927445 399.44726873 359.77907651 C399.46100361 338.6668067 399.4555491 317.55457393 399.44408352 296.44230496 C399.43414966 277.11819182 399.44709272 257.79417441 399.47101771 238.47007603 C399.49538684 218.63816116 399.50502199 198.80629091 399.49836498 178.97436136 C399.49486796 167.83618698 399.4971367 156.69808625 399.51461601 145.55992317 C399.52931065 136.0784147 399.53000932 126.59703173 399.5125451 117.11552579 C399.50401021 112.27630734 399.50194611 107.43731335 399.51719666 102.59810638 C399.53097977 98.16978235 399.52636324 93.74187644 399.50695742 89.31357699 C399.50317742 87.70999763 399.50617659 86.1063853 399.51656907 84.50283516 C399.52968102 82.32514008 399.51820973 80.14890053 399.50057125 77.97126865 C399.50046391 76.76115228 399.50035658 75.55103591 399.50024599 74.30424935 C398.71985807 69.14959275 396.20236582 66.07826224 392.38867188 62.65820312 C387.76440864 60.39537921 383.86521113 60.42470171 378.78125 60.46875 C377.80514771 60.4649231 376.82904541 60.46109619 375.82336426 60.45715332 C373.76585861 60.45443926 371.70831816 60.46176491 369.65087891 60.47851562 C366.50995618 60.49993211 363.37132073 60.47869636 360.23046875 60.453125 C358.22655747 60.45576837 356.22264762 60.46089352 354.21875 60.46875 C352.81695496 60.45660461 352.81695496 60.45660461 351.38684082 60.44421387 C345.76984243 60.52459244 342.41134766 61.18004111 338 65 C336.60644236 66.95851344 335.25717453 68.95127113 334 71 C333.67 71 333.34 71 333 71 C333 60.77 333 50.54 333 40 C326.4 40 319.8 40 313 40 C313 46.6 313 53.2 313 60 C306.4 60 299.8 60 293 60 C293 66.6 293 73.2 293 80 C286.4 80 279.8 80 273 80 C273 73.4 273 66.8 273 60 C253.2 60 233.4 60 213 60 C213 53.4 213 46.8 213 40 C206.4 40 199.8 40 193 40 C193 46.6 193 53.2 193 60 C186.4 60 179.8 60 173 60 C173 66.6 173 73.2 173 80 C179.6 80 186.2 80 193 80 C193 86.6 193 93.2 193 100 C186.4 100 179.8 100 173 100 C173 106.6 173 113.2 173 120 C179.6 120 186.2 120 193 120 C193 126.6 193 133.2 193 140 C186.4 140 179.8 140 173 140 C173 146.6 173 153.2 173 160 C179.6 160 186.2 160 193 160 C193 166.6 193 173.2 193 180 C186.4 180 179.8 180 173 180 C173 186.6 173 193.2 173 200 C179.6 200 186.2 200 193 200 C193 206.6 193 213.2 193 220 C186.4 220 179.8 220 173 220 C173 226.6 173 233.2 173 240 C179.6 240 186.2 240 193 240 C193 246.6 193 253.2 193 260 C186.4 260 179.8 260 173 260 C173 266.6 173 273.2 173 280 C179.6 280 186.2 280 193 280 C193 286.6 193 293.2 193 300 C186.4 300 179.8 300 173 300 C173 306.6 173 313.2 173 320 C179.6 320 186.2 320 193 320 C193 326.6 193 333.2 193 340 C186.4 340 179.8 340 173 340 C173 346.6 173 353.2 173 360 C179.6 360 186.2 360 193 360 C193 366.6 193 373.2 193 380 C186.4 380 179.8 380 173 380 C173 386.6 173 393.2 173 400 C179.6 400 186.2 400 193 400 C193 406.6 193 413.2 193 420 C186.4 420 179.8 420 173 420 C173 426.6 173 433.2 173 440 C179.6 440 186.2 440 193 440 C193 446.6 193 453.2 193 460 C186.4 460 179.8 460 173 460 C173 466.6 173 473.2 173 480 C179.6 480 186.2 480 193 480 C193 486.6 193 493.2 193 500 C186.4 500 179.8 500 173 500 C173 506.6 173 513.2 173 520 C166.4 520 159.8 520 153 520 C153 513.4 153 506.8 153 500 C146.4 500 139.8 500 133 500 C133 493.4 133 486.8 133 480 C139.6 480 146.2 480 153 480 C153 473.4 153 466.8 153 460 C146.73 460 140.46 460 134 460 C133.99761165 458.01103636 133.99522329 456.02207272 133.99276257 453.97283745 C133.93563271 406.78247655 133.86271945 359.59216024 133.77101372 312.40185338 C133.75974525 306.59635299 133.74860685 300.79085236 133.73754883 294.98535156 C133.7342433 293.25166048 133.7342433 293.25166048 133.730871 291.48294534 C133.69547713 272.75671186 133.6706248 254.03047843 133.64965298 235.30422388 C133.62790757 216.0962173 133.59486915 196.88825422 133.55129844 177.68028462 C133.52476002 165.82336882 133.50708078 153.96650723 133.50065396 142.10956319 C133.49540678 133.98410686 133.47921238 125.85871882 133.45433434 117.73329906 C133.44029638 113.04200515 133.4311571 108.35083353 133.43499184 103.65951729 C133.43839498 99.36611717 133.42807826 95.07297853 133.40676448 90.77963199 C133.40148387 89.22503574 133.40127498 87.67041242 133.40660437 86.11581634 C133.41310658 84.00430134 133.40122813 81.89365225 133.38476086 79.7822094 C133.38286225 78.60887358 133.38096365 77.43553776 133.37900752 76.2266463 C132.726223 70.6692242 130.29544192 66.53742276 126 63 C121.22803542 60.42910264 116.41645437 60.65988384 111.1328125 60.62890625 C110.17986298 60.61987778 109.22691345 60.6108493 108.24508667 60.60154724 C106.23292166 60.58706716 104.2207098 60.57816359 102.20849609 60.57446289 C99.14209118 60.56256631 96.0776994 60.51335843 93.01171875 60.46289062 C91.05209311 60.45342553 89.09245516 60.44619091 87.1328125 60.44140625 C86.22218048 60.42187393 85.31154846 60.40234161 84.37332153 60.38221741 C79.05775641 60.41959862 75.71529143 61.18375344 71.46798706 64.43760681 C67.50867431 68.65154264 66.62456304 72.10680714 66.61968327 77.82701683 C66.61502335 78.50434998 66.61036343 79.18168312 66.6055623 79.87954152 C66.59359207 82.15380824 66.60301517 84.42747978 66.61231995 86.70175171 C66.6081479 88.34687719 66.60267109 89.99199979 66.59600013 91.63711703 C66.5815097 96.16159108 66.58580146 100.68588353 66.59316695 105.21036768 C66.59788746 110.08845907 66.58539864 114.96651054 66.57514954 119.84458923 C66.55793397 129.40280987 66.55712728 138.96096485 66.56236244 148.51919697 C66.56640042 156.28695053 66.56496501 164.05468466 66.55961418 171.82243729 C66.55886576 172.92710791 66.55811734 174.03177854 66.55734624 175.16992403 C66.55581479 177.41391924 66.55427644 179.65791446 66.55273127 181.90190966 C66.53899613 202.95650575 66.54445093 224.01106471 66.55591648 245.06565996 C66.5658489 264.33413217 66.55290981 283.60250836 66.52898229 302.87096576 C66.50460853 322.64751489 66.49497924 342.42401925 66.50163502 362.2005831 C66.5051312 373.30693136 66.5028689 384.41320577 66.48538399 395.51954269 C66.47068352 404.97467227 66.46999829 414.42967599 66.4874549 423.88480304 C66.49598523 428.70996875 66.49806495 433.53490941 66.48280334 438.36006355 C66.46900662 442.77672082 66.47365453 447.19295919 66.49304258 451.60959192 C66.49681837 453.20780552 66.49383532 454.80605228 66.48343093 456.40423648 C66.22276209 467.41286824 66.22276209 467.41286824 71 477 C71.66 477.66 72.32 478.32 73 479 C73.22705078 481.15478516 73.22705078 481.15478516 73.1953125 483.7890625 C73.18886719 484.73007812 73.18242187 485.67109375 73.17578125 486.640625 C73.15902344 487.62546875 73.14226562 488.6103125 73.125 489.625 C73.11597656 490.61757813 73.10695313 491.61015625 73.09765625 492.6328125 C73.07404249 495.08864388 73.0381707 497.54435174 73 500 C66.4 500 59.8 500 53 500 C53 506.6 53 513.2 53 520 C46.4 520 39.8 520 33 520 C33 523.96 33 527.92 33 532 C23.5916245 532.31713625 17.51010884 531.94685101 9.9375 526 C2.53150663 518.88640341 -0.48018728 511.84057541 -0.73828697 501.66599751 C-0.78589959 497.86885702 -0.75644915 494.07480944 -0.7215271 490.27766418 C-0.7241456 488.16039288 -0.72940284 486.04312347 -0.7370621 483.9258644 C-0.75044943 478.12426233 -0.7265185 472.32332751 -0.69639373 466.52181041 C-0.67044875 460.25950552 -0.67925363 453.99723733 -0.68380737 447.7348938 C-0.68695133 436.89043551 -0.66835898 426.04624456 -0.63438034 415.2018528 C-0.59884579 403.83167301 -0.57577816 392.46157975 -0.56926346 381.09134483 C-0.56885102 380.38367776 -0.56843858 379.6760107 -0.56801365 378.94689917 C-0.56598357 375.35283484 -0.5641753 371.75877044 -0.56245239 368.16470595 C-0.54985883 342.72554919 -0.50945964 317.28650531 -0.45263672 291.84741211 C-0.397507 267.13778279 -0.35501668 242.42818438 -0.32958984 217.71850586 C-0.32880069 216.95649008 -0.32801153 216.19447429 -0.32719846 215.40936712 C-0.31928716 207.75670581 -0.3116323 200.10404425 -0.3041653 192.45138249 C-0.28894911 176.86282492 -0.2720216 161.27426936 -0.25405884 145.68571472 C-0.2532351 144.96902007 -0.25241136 144.25232542 -0.25156266 143.51391275 C-0.19638345 95.67589339 -0.10085321 47.83794249 0 0 Z ",
    fill: "#F1F1F1",
    transform: "translate(187,240)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.4329818 -0.00430527 1.4329818 -0.00430527 2.89491272 -0.00869751 C4.91131179 -0.01073508 6.92773076 -0.00522675 8.9440918 0.00732422 C12.02112325 0.02336435 15.09683771 0.00747399 18.17382812 -0.01171875 C20.13672164 -0.00973592 22.09961433 -0.00589142 24.0625 0 C24.9782933 -0.00607269 25.89408661 -0.01214539 26.83763123 -0.0184021 C33.58254964 0.05539359 38.18295399 1.32046002 43.2226162 6.0164175 C47.98962106 11.75861752 46.91625672 19.36640837 46.84609985 26.4233551 C46.85158276 28.07917567 46.85968841 29.73498927 46.87018716 31.39078563 C46.89135462 35.93569136 46.87510838 40.47981005 46.85268617 45.02468145 C46.8350013 49.92795747 46.8518893 54.83113055 46.8644104 59.73440552 C46.88338973 69.3375592 46.87018425 78.94041238 46.84588452 88.54354376 C46.81864732 99.72382758 46.82191995 110.90403975 46.82615118 122.08434831 C46.83253136 142.03049641 46.80919275 161.97650168 46.77001953 181.92260742 C46.7320059 201.28332875 46.7178457 220.64388269 46.72900391 240.00463867 C46.74111545 261.08191365 46.74077318 282.159115 46.71803224 303.23638386 C46.71561763 305.48317555 46.71320566 307.72996725 46.71079636 309.97675896 C46.70958928 311.08225799 46.7083822 312.18775702 46.70713855 313.32675602 C46.69937538 321.12266211 46.70016933 328.91854083 46.70396805 336.71444893 C46.70820925 346.21239794 46.69778434 355.71020024 46.66874094 365.2081079 C46.65423908 370.0554279 46.64611063 374.90253408 46.65522766 379.74987221 C46.66336759 384.18554024 46.65308736 388.62076636 46.62797551 393.05636727 C46.62210936 394.66256953 46.62300066 396.26881334 46.63126166 397.87500507 C46.64146335 400.05624472 46.62712111 402.23600216 46.60660744 404.4171381 C46.60400711 406.23524308 46.60400711 406.23524308 46.60135424 408.09007746 C45.75698967 413.63598407 42.33865656 418.01850887 37.93701172 421.45407104 C34.09403953 423.42713938 29.88615486 423.08592693 25.66015625 423.02734375 C24.66185791 423.02975571 23.66355957 423.03216766 22.63500977 423.03465271 C20.53039567 423.03367591 18.42575536 423.02032248 16.32128906 422.99536133 C13.1078322 422.96104616 9.89712618 422.97471385 6.68359375 422.99414062 C4.63410293 422.98724184 2.58461918 422.97756916 0.53515625 422.96484375 C-0.42124756 422.96980362 -1.37765137 422.97476349 -2.36303711 422.97987366 C-8.04550783 422.88001128 -11.41443763 422.22467643 -15.90234375 418.3984375 C-20.28399673 413.54309231 -21.0268 410.2681935 -21.04215145 403.82030964 C-21.04510287 403.14558378 -21.0480543 402.47085792 -21.05109516 401.77568582 C-21.05980696 399.49842008 -21.06136868 397.22120501 -21.06297302 394.94392395 C-21.06770257 393.30123975 -21.07285329 391.65855672 -21.07839066 390.01587504 C-21.09231681 385.48887271 -21.099886 380.96187843 -21.10636365 376.43486011 C-21.11272913 372.55516145 -21.12279997 368.67547605 -21.13292431 364.79578564 C-21.1662671 352.01272102 -21.1877724 339.22964832 -21.20612416 326.44655445 C-21.21091807 323.11895421 -21.21590152 319.79135431 -21.22092938 316.46375442 C-21.25189769 295.80821639 -21.27858832 275.15267559 -21.29534817 254.49712086 C-21.29929779 249.71154081 -21.30330077 244.92596081 -21.30737305 240.14038086 C-21.30838141 238.95092055 -21.30938977 237.76146025 -21.31042869 236.53595569 C-21.32744057 217.26153867 -21.36855502 197.98724992 -21.41939604 178.71289555 C-21.47114218 158.93302526 -21.50028641 139.15322099 -21.50754505 119.37328357 C-21.51221091 108.26401515 -21.52700011 97.15495686 -21.56728935 86.04575539 C-21.60155527 76.58582783 -21.61554256 67.1261483 -21.60286521 57.66616223 C-21.59703042 52.83873894 -21.60095997 48.01184042 -21.63103485 43.18449593 C-21.65834757 38.76447721 -21.65793659 34.34535731 -21.6355244 29.92531904 C-21.63229531 28.32701336 -21.63920582 26.72864803 -21.65732162 25.13044176 C-21.8110167 10.69523471 -21.8110167 10.69523471 -16.4095636 4.77567405 C-11.15455775 -0.02613778 -6.87729993 -0.0455033 0 0 Z ",
    fill: "#020202",
    transform: "translate(273.90234375,299.6015625)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.30760033 -0.03377747 1.30760033 -0.03377747 2.64161682 -0.0682373 C6.65014888 -0.13943446 10.65849576 -0.19682455 14.66748047 -0.23535156 C16.77513437 -0.26188939 18.88266016 -0.30273771 20.98974609 -0.35839844 C24.03788437 -0.43795051 27.08354087 -0.47073579 30.13256836 -0.49414062 C31.52995995 -0.54362854 31.52995995 -0.54362854 32.95558167 -0.59411621 C39.46519995 -0.57445933 43.01252208 1.17468592 47.99534607 5.32800293 C51.74299519 9.29981247 52.0366447 12.54612108 52.04776764 17.94140244 C52.05187291 18.61897051 52.05597817 19.29653859 52.06020784 19.99463904 C52.07155851 22.2756124 52.06863216 24.55634463 52.0657959 26.83734131 C52.07096258 28.48501497 52.07698872 30.13268612 52.0838027 31.78035378 C52.09995658 36.31651362 52.1035226 40.85261018 52.10499763 45.38879538 C52.10869633 50.27782995 52.12378977 55.1668316 52.13726807 60.05584717 C52.16444528 70.7500167 52.17648569 81.44417124 52.18528938 92.13836956 C52.19081227 98.81405392 52.1992866 105.48973247 52.20829773 112.1654129 C52.23268411 130.64334118 52.25328276 149.12126481 52.26004791 167.59920883 C52.26070661 169.37354611 52.26070661 169.37354611 52.26137862 171.18372859 C52.26203345 172.96234327 52.26203345 172.96234327 52.26270151 174.77688956 C52.26358845 177.17971023 52.26448157 179.5825309 52.26538086 181.98535156 C52.26582372 183.17723698 52.26626658 184.3691224 52.26672286 185.59712556 C52.27462028 204.91351749 52.30953224 224.22975859 52.3560999 243.54609224 C52.40350892 263.37120109 52.42845078 283.19623422 52.43078375 303.02140069 C52.43261826 314.15523761 52.44414803 325.28887799 52.48042297 336.42266083 C52.51120073 345.90270203 52.52148043 355.38248598 52.50494677 364.86256763 C52.49712497 369.70011695 52.49903423 374.53714801 52.52706146 379.37463379 C52.55248893 383.8038752 52.55019116 388.23220762 52.52588004 392.66144732 C52.52195704 394.26308321 52.52816527 395.86478293 52.54556876 397.46632907 C52.69267807 411.91991438 52.69267807 411.91991438 47.33922148 417.84932923 C41.90318162 422.65923247 36.5605521 422.71536942 29.63647461 422.76367188 C28.66511566 422.77602875 27.69375671 422.78838562 26.69296265 422.80111694 C24.64392084 422.82063202 22.59478597 422.83190624 20.5456543 422.83544922 C17.42588686 422.84953724 14.31012516 422.91691938 11.19116211 422.98632812 C9.19378397 422.99872798 7.19638303 423.00794687 5.19897461 423.01367188 C4.27476715 423.04038971 3.35055969 423.06710754 2.39834595 423.09463501 C-3.88875797 423.02930381 -7.09155803 421.45113405 -11.63589478 417.1187439 C-15.07294317 412.99623858 -15.46612892 409.85255396 -15.4723568 404.50222969 C-15.47586287 403.82406242 -15.47936895 403.14589515 -15.48298126 402.44717735 C-15.49231952 400.16417698 -15.48736578 397.88143034 -15.48251343 395.59841919 C-15.48624847 393.94932086 -15.4908494 392.3002243 -15.49624407 390.65113056 C-15.50850753 386.1111019 -15.50820968 381.57114674 -15.50585532 377.03110528 C-15.505448 372.13802463 -15.51647816 367.24496781 -15.52597046 362.35189819 C-15.54259954 352.76247413 -15.54808086 343.17307465 -15.54919522 333.58363737 C-15.55014474 325.79106428 -15.55425027 317.99849932 -15.56059647 310.2059288 C-15.57821374 288.12493989 -15.58743453 266.04397044 -15.58593552 243.96297444 C-15.58585561 242.77201417 -15.58577569 241.58105389 -15.58569336 240.35400391 C-15.5856116 239.16159387 -15.58552984 237.96918383 -15.5854456 236.74064015 C-15.58463246 217.41000027 -15.60377585 198.07943826 -15.63197009 178.74882092 C-15.66067435 158.91242207 -15.67451176 139.07606123 -15.67278254 119.23964107 C-15.67211781 108.09809321 -15.67764649 96.956627 -15.69913864 85.81509781 C-15.71731807 76.32991172 -15.72172444 66.84484429 -15.70811979 57.35964836 C-15.70157388 52.51840715 -15.70153135 47.67739378 -15.71882629 42.83617401 C-15.73449044 38.40596716 -15.73176194 33.97617009 -15.71425803 29.54597364 C-15.7111734 27.94168841 -15.71487529 26.3373731 -15.72597818 24.73312332 C-15.74006007 22.55447438 -15.72954604 20.37727067 -15.71286583 18.19867134 C-15.71330057 16.9880129 -15.7137353 15.77735445 -15.71418321 14.53000939 C-14.93561582 9.37372649 -12.43649871 6.30061414 -8.59008789 2.91210938 C-5.45253997 0.68279901 -3.78680321 0.09317572 0 0 Z ",
    fill: "#020202",
    transform: "translate(535.215087890625,299.775390625)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.94774796 -0.00619858 1.89549591 -0.01239716 2.8719635 -0.01878357 C4.86800108 -0.02585891 6.86409795 -0.02274785 8.86010742 -0.01000977 C11.89808805 0.00385119 14.9329823 -0.03024339 17.97070312 -0.06835938 C19.9179695 -0.06931077 21.86523969 -0.06745065 23.8125 -0.0625 C24.71169662 -0.07575821 25.61089325 -0.08901642 26.53733826 -0.10267639 C32.71017655 -0.01247758 37.36006498 1.29817592 41.97265625 5.56640625 C44.91868959 9.60496359 45.3493583 12.48302516 45.3557663 17.44027519 C45.36072581 18.12267346 45.36568533 18.80507173 45.37079513 19.50814873 C45.38377049 21.79963778 45.37536074 24.09054598 45.36706543 26.38204956 C45.37195343 28.03954995 45.37814281 29.69704692 45.38552332 31.35453808 C45.40195758 35.91321077 45.39959783 40.47171091 45.39414835 45.0304029 C45.39148244 49.94530862 45.40600168 54.8601679 45.41824341 59.77505493 C45.4393182 69.4054612 45.44383709 79.03580729 45.44205552 88.66623388 C45.44074893 96.49262656 45.4445468 104.31900042 45.45198059 112.14538956 C45.45407974 114.39806115 45.45617734 116.65073275 45.45827341 118.90340436 C45.45931694 120.02455333 45.46036047 121.14570231 45.46143562 122.30082549 C45.48034626 143.51422417 45.47928526 164.72758828 45.47246629 185.94099189 C45.46689021 205.35497827 45.48771757 224.7688327 45.52082676 244.18278824 C45.55454543 264.10850037 45.56973436 284.03414928 45.56510973 303.95989048 C45.5628632 315.15009614 45.56813509 326.34017985 45.59300232 337.53036118 C45.61399188 347.05687405 45.61763072 356.5831981 45.59870273 366.10971867 C45.58953044 370.9713868 45.58844752 375.83270266 45.60905838 380.69434357 C45.62771581 385.14438294 45.62332396 389.59378024 45.60051256 394.04379477 C45.59631353 395.6541235 45.6005705 397.26450096 45.6141085 398.87477826 C45.72012799 412.40616801 45.72012799 412.40616801 42.60092926 416.95135689 C37.58569266 421.94136029 33.43861026 422.91024577 26.58581543 423.00889587 C25.6512854 423.00596024 24.71675537 423.0030246 23.75390625 423 C22.77780396 423.00524185 21.80170166 423.0104837 20.79602051 423.0158844 C18.73853504 423.02228911 16.68101288 423.02098776 14.62353516 423.01245117 C11.48273368 423.00393358 8.34374741 423.03273712 5.203125 423.06445312 C3.19921929 423.06606517 1.19531038 423.06548754 -0.80859375 423.0625 C-1.74312378 423.07373398 -2.67765381 423.08496796 -3.64050293 423.09654236 C-9.25520372 423.03676439 -12.68167142 422.4671916 -17.02734375 418.56640625 C-20.53729165 414.10597641 -21.52768888 411.21887548 -21.53070831 405.56669617 C-21.53652208 404.88284446 -21.54233584 404.19899275 -21.54832578 403.49441826 C-21.56291914 401.20384507 -21.54904471 398.9143446 -21.53527832 396.6237793 C-21.53988752 394.9647018 -21.54624057 393.30562839 -21.5541873 391.64656353 C-21.57090116 387.08815958 -21.56262493 382.53009016 -21.55024242 377.97168493 C-21.54120267 373.0554511 -21.55515632 368.13927533 -21.56616211 363.22305298 C-21.5839634 353.59242432 -21.58010017 343.96192024 -21.56851155 334.33128667 C-21.55948384 326.50538309 -21.55825036 318.67951447 -21.56260681 310.85360718 C-21.56321974 309.74045724 -21.56383268 308.62730729 -21.56446418 307.48042554 C-21.56574306 305.21919512 -21.56703991 302.95796471 -21.56835455 300.69673431 C-21.57976506 279.48525215 -21.56663923 258.2738391 -21.54515308 237.06236827 C-21.52728169 218.85567184 -21.53038566 200.64907741 -21.54882812 182.44238281 C-21.5702265 161.30762584 -21.57866638 140.17292947 -21.56637907 119.03816319 C-21.56510485 116.78517724 -21.56384737 114.53219129 -21.56260681 112.27920532 C-21.56168116 110.61636813 -21.56168116 110.61636813 -21.56073681 108.91993827 C-21.55728081 101.10199607 -21.56311764 93.28409226 -21.57252502 85.46615601 C-21.5837349 75.94074809 -21.58072624 66.41547204 -21.55940205 56.89007926 C-21.54887804 52.02858073 -21.54479283 47.16730219 -21.55799866 42.30580521 C-21.56990039 37.85715967 -21.56339676 33.40893849 -21.54208845 28.96033156 C-21.53761296 27.34938274 -21.53990987 25.73839822 -21.5495916 24.12747228 C-21.56173281 21.9398419 -21.5493058 19.75367027 -21.53070831 17.56611633 C-21.5300589 16.35046651 -21.52940949 15.13481668 -21.52874041 13.88232899 C-20.71070206 8.47233691 -18.20984501 5.4521961 -13.90405273 2.22680664 C-9.40864451 -0.07806619 -4.96322789 -0.02731513 0 0 Z ",
    fill: "#000000",
    transform: "translate(408.02734375,299.43359375)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.78509949 0.00703949 1.57019897 0.01407898 2.37908936 0.02133179 C3.21059509 0.0342778 4.04210083 0.04722382 4.89880371 0.06056213 C5.79730042 0.07016968 6.69579712 0.07977722 7.621521 0.0896759 C10.564946 0.1224215 13.50821099 0.16284539 16.45153809 0.2033844 C18.50276134 0.22770946 20.55399038 0.25155179 22.60522461 0.27493286 C27.98432025 0.33753648 33.36331265 0.40666943 38.74230957 0.47718811 C44.23908822 0.54808676 49.73593963 0.61277456 55.23278809 0.67799377 C66.0037014 0.80670002 76.77451583 0.94230808 87.54528809 1.08229065 C87.54626489 2.18400642 87.5472417 3.28572218 87.54824811 4.42082328 C87.59150297 52.98570831 87.63846292 101.55058786 87.70426941 150.115448 C87.70526498 150.85094599 87.70626054 151.58644398 87.70728628 152.34422979 C87.7289459 168.3294104 87.75126867 184.31459001 87.77427437 200.29976873 C87.78555267 208.13914109 87.79668447 215.97851367 87.80773926 223.81788635 C87.80884182 224.59798921 87.80994439 225.37809207 87.81108037 226.18183442 C87.84673518 251.45740868 87.87271965 276.73298163 87.89367777 302.008572 C87.91526999 327.98719239 87.94664125 353.96578312 87.99027922 379.94437628 C87.99644127 383.615483 88.00249178 387.2865899 88.00847435 390.95769691 C88.00965523 391.68020812 88.01083611 392.40271932 88.01205278 393.1471248 C88.03075858 404.76747188 88.03918626 416.38780467 88.04374933 428.00816496 C88.04855926 439.69666482 88.0644879 451.38510155 88.09095374 463.07357355 C88.10496413 469.40416662 88.11414121 475.73466947 88.11029625 482.06527901 C88.10688078 487.86464518 88.1172814 493.66381883 88.1385236 499.46314559 C88.14378271 501.55756907 88.14403566 503.6520126 88.13868371 505.74643584 C88.10556201 520.18231861 89.21827021 532.67251588 95.04528809 546.08229065 C95.3404834 546.79256409 95.63567871 547.50283752 95.93981934 548.2346344 C97.5547683 552.05502028 99.40087014 555.52569503 101.54528809 559.08229065 C101.54528809 559.74229065 101.54528809 560.40229065 101.54528809 561.08229065 C96.92528809 561.08229065 92.30528809 561.08229065 87.54528809 561.08229065 C87.54528809 554.48229065 87.54528809 547.88229065 87.54528809 541.08229065 C80.94528809 541.08229065 74.34528809 541.08229065 67.54528809 541.08229065 C67.54528809 534.48229065 67.54528809 527.88229065 67.54528809 521.08229065 C60.94528809 521.08229065 54.34528809 521.08229065 47.54528809 521.08229065 C47.54528809 514.48229065 47.54528809 507.88229065 47.54528809 501.08229065 C54.14528809 501.08229065 60.74528809 501.08229065 67.54528809 501.08229065 C67.54528809 494.48229065 67.54528809 487.88229065 67.54528809 481.08229065 C60.94528809 481.08229065 54.34528809 481.08229065 47.54528809 481.08229065 C47.54528809 474.48229065 47.54528809 467.88229065 47.54528809 461.08229065 C54.14528809 461.08229065 60.74528809 461.08229065 67.54528809 461.08229065 C67.54528809 454.48229065 67.54528809 447.88229065 67.54528809 441.08229065 C60.94528809 441.08229065 54.34528809 441.08229065 47.54528809 441.08229065 C47.54528809 434.48229065 47.54528809 427.88229065 47.54528809 421.08229065 C54.14528809 421.08229065 60.74528809 421.08229065 67.54528809 421.08229065 C67.54528809 414.48229065 67.54528809 407.88229065 67.54528809 401.08229065 C60.94528809 401.08229065 54.34528809 401.08229065 47.54528809 401.08229065 C47.54528809 394.48229065 47.54528809 387.88229065 47.54528809 381.08229065 C54.14528809 381.08229065 60.74528809 381.08229065 67.54528809 381.08229065 C67.54528809 374.48229065 67.54528809 367.88229065 67.54528809 361.08229065 C60.94528809 361.08229065 54.34528809 361.08229065 47.54528809 361.08229065 C47.54528809 354.48229065 47.54528809 347.88229065 47.54528809 341.08229065 C54.14528809 341.08229065 60.74528809 341.08229065 67.54528809 341.08229065 C67.54528809 334.48229065 67.54528809 327.88229065 67.54528809 321.08229065 C60.94528809 321.08229065 54.34528809 321.08229065 47.54528809 321.08229065 C47.54528809 314.48229065 47.54528809 307.88229065 47.54528809 301.08229065 C54.14528809 301.08229065 60.74528809 301.08229065 67.54528809 301.08229065 C67.54528809 294.48229065 67.54528809 287.88229065 67.54528809 281.08229065 C60.94528809 281.08229065 54.34528809 281.08229065 47.54528809 281.08229065 C47.54528809 274.48229065 47.54528809 267.88229065 47.54528809 261.08229065 C54.14528809 261.08229065 60.74528809 261.08229065 67.54528809 261.08229065 C67.54528809 254.48229065 67.54528809 247.88229065 67.54528809 241.08229065 C60.94528809 241.08229065 54.34528809 241.08229065 47.54528809 241.08229065 C47.54528809 234.48229065 47.54528809 227.88229065 47.54528809 221.08229065 C54.14528809 221.08229065 60.74528809 221.08229065 67.54528809 221.08229065 C67.54528809 214.48229065 67.54528809 207.88229065 67.54528809 201.08229065 C60.94528809 201.08229065 54.34528809 201.08229065 47.54528809 201.08229065 C47.54528809 194.48229065 47.54528809 187.88229065 47.54528809 181.08229065 C54.14528809 181.08229065 60.74528809 181.08229065 67.54528809 181.08229065 C67.54528809 174.48229065 67.54528809 167.88229065 67.54528809 161.08229065 C60.94528809 161.08229065 54.34528809 161.08229065 47.54528809 161.08229065 C47.54528809 154.48229065 47.54528809 147.88229065 47.54528809 141.08229065 C54.14528809 141.08229065 60.74528809 141.08229065 67.54528809 141.08229065 C67.54528809 134.48229065 67.54528809 127.88229065 67.54528809 121.08229065 C60.94528809 121.08229065 54.34528809 121.08229065 47.54528809 121.08229065 C47.54528809 114.48229065 47.54528809 107.88229065 47.54528809 101.08229065 C54.14528809 101.08229065 60.74528809 101.08229065 67.54528809 101.08229065 C67.54528809 94.48229065 67.54528809 87.88229065 67.54528809 81.08229065 C60.94528809 81.08229065 54.34528809 81.08229065 47.54528809 81.08229065 C47.54528809 74.48229065 47.54528809 67.88229065 47.54528809 61.08229065 C54.14528809 61.08229065 60.74528809 61.08229065 67.54528809 61.08229065 C67.54528809 54.48229065 67.54528809 47.88229065 67.54528809 41.08229065 C60.94528809 41.08229065 54.34528809 41.08229065 47.54528809 41.08229065 C47.54528809 34.48229065 47.54528809 27.88229065 47.54528809 21.08229065 C54.14528809 21.08229065 60.74528809 21.08229065 67.54528809 21.08229065 C67.54528809 14.81229065 67.54528809 8.54229065 67.54528809 2.08229065 C47.74528809 2.08229065 27.94528809 2.08229065 7.54528809 2.08229065 C7.54528809 8.35229065 7.54528809 14.62229065 7.54528809 21.08229065 C0.94528809 21.08229065 -5.65471191 21.08229065 -12.45471191 21.08229065 C-12.45471191 14.48229065 -12.45471191 7.88229065 -12.45471191 1.08229065 C-3.45471191 -0.04270935 -3.45471191 -0.04270935 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(32.4547119140625,238.91770935058594)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.48306794 -0.00379249 2.96613231 -0.00930013 4.44918823 -0.01637268 C8.44091087 -0.03022118 12.43219737 -0.01923416 16.42389536 -0.00266147 C20.62056136 0.01128995 24.81720461 0.00471775 29.0138855 0.00120544 C36.05620268 -0.00148817 43.09834859 0.01190753 50.140625 0.03515625 C58.26142237 0.06178134 66.38193396 0.06350334 74.50276005 0.05176789 C82.34523908 0.04095933 90.1876156 0.04719993 98.03008652 0.06132317 C101.35440392 0.06705425 104.67864559 0.06702315 108.00296402 0.06225777 C111.92166093 0.05745736 115.840048 0.06771521 119.75868607 0.08921242 C121.18966121 0.09473824 122.62066638 0.09528464 124.05164337 0.09025955 C137.13255782 0.05011118 149.34067385 1.99347002 159.09326172 11.31420898 C164.41530505 16.64724827 167.23337475 23.00019508 169.71826172 30.00170898 C170.23241098 31.41240396 170.74807428 32.82254792 171.26513672 34.23217773 C171.52488281 34.94164551 171.78462891 35.65111328 172.05224609 36.38208008 C173.29694299 39.71740675 174.63110041 43.01511222 175.96826172 46.31420898 C177.75391926 50.75955643 179.52961967 55.20598325 181.21826172 59.68920898 C181.53537109 60.52838867 181.85248047 61.36756836 182.17919922 62.23217773 C182.84326172 64.50170898 182.84326172 64.50170898 182.84326172 68.50170898 C102.98326172 68.50170898 23.12326172 68.50170898 -59.15673828 68.50170898 C-58.43487999 63.44870095 -57.92902407 60.38095291 -56.08251953 55.91186523 C-55.66518555 54.88762451 -55.24785156 53.86338379 -54.81787109 52.80810547 C-54.15029785 51.20237671 -54.15029785 51.20237671 -53.46923828 49.56420898 C-52.55214435 47.32793824 -51.63677838 45.09095808 -50.72314453 42.85327148 C-50.05822998 41.22566895 -50.05822998 41.22566895 -49.37988281 39.56518555 C-48.04277383 36.21627467 -46.8133053 32.84138202 -45.61523438 29.44091797 C-43.33995769 23.01259489 -40.95520997 17.4679594 -36.15673828 12.50170898 C-35.51091797 11.80561523 -34.86509766 11.10952148 -34.19970703 10.39233398 C-24.48125496 0.79645699 -13.09875923 -0.09661396 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(358.15673828125,104.498291015625)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C13.2 0 26.4 0 40 0 C40 118.8 40 237.6 40 360 C33.4 360 26.8 360 20 360 C20 353.4 20 346.8 20 340 C13.4 340 6.8 340 0 340 C0 333.4 0 326.8 0 320 C6.6 320 13.2 320 20 320 C20 313.4 20 306.8 20 300 C13.4 300 6.8 300 0 300 C0 293.4 0 286.8 0 280 C6.6 280 13.2 280 20 280 C20 273.4 20 266.8 20 260 C13.4 260 6.8 260 0 260 C0 253.4 0 246.8 0 240 C6.6 240 13.2 240 20 240 C20 233.4 20 226.8 20 220 C13.4 220 6.8 220 0 220 C0 213.4 0 206.8 0 200 C6.6 200 13.2 200 20 200 C20 193.4 20 186.8 20 180 C13.4 180 6.8 180 0 180 C0 173.4 0 166.8 0 160 C6.6 160 13.2 160 20 160 C20 153.4 20 146.8 20 140 C13.4 140 6.8 140 0 140 C0 133.4 0 126.8 0 120 C6.6 120 13.2 120 20 120 C20 113.4 20 106.8 20 100 C13.4 100 6.8 100 0 100 C0 93.4 0 86.8 0 80 C6.6 80 13.2 80 20 80 C20 73.4 20 66.8 20 60 C13.4 60 6.8 60 0 60 C0 53.4 0 46.8 0 40 C6.6 40 13.2 40 20 40 C20 33.4 20 26.8 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,340)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C17.75390625 21.13932292 15.5078125 22.27864583 13.26171875 23.41796875 C10.48053339 25.36335747 9.4901518 26.94902945 8 30 C7.55005357 33.26469784 7.55005357 33.26469784 7.61688995 36.87386894 C7.60945068 37.89746634 7.60945068 37.89746634 7.60186112 38.94174248 C7.58888576 41.23323153 7.59729551 43.52413973 7.60559082 45.81564331 C7.60070282 47.4731437 7.59451344 49.13064067 7.58713293 50.78813183 C7.57069867 55.34680452 7.57305842 59.90530466 7.5785079 64.46399665 C7.58117381 69.37890237 7.56665457 74.29376165 7.55441284 79.20864868 C7.53333805 88.83905495 7.52881916 98.46940104 7.53060073 108.09982763 C7.53190732 115.92622031 7.52810945 123.75259417 7.52067566 131.57898331 C7.51857651 133.8316549 7.51647891 136.0843265 7.51438284 138.33699811 C7.51281755 140.01872157 7.51281755 140.01872157 7.51122063 141.73441924 C7.49230999 162.94781792 7.49337099 184.16118203 7.50018996 205.37458564 C7.50576604 224.78857202 7.48493868 244.20242645 7.45182949 263.61638199 C7.41811082 283.54209412 7.40292189 303.46774303 7.40754652 323.39348423 C7.40979305 334.58368989 7.40452116 345.7737736 7.37965393 356.96395493 C7.35866437 366.4904678 7.35502553 376.01679185 7.37395352 385.54331242 C7.38312581 390.40498055 7.38420873 395.26629641 7.36359787 400.12793732 C7.34494044 404.57797669 7.34933229 409.02737399 7.37214369 413.47738852 C7.37634272 415.08771725 7.37208575 416.69809471 7.35854775 418.30837201 C6.9945516 427.81393563 6.9945516 427.81393563 10.41150284 436.41575241 C14.04880593 440.04708409 16.30610876 441.22893133 21.40136719 441.31884766 C22.2619574 441.33871735 23.12254761 441.35858704 24.00921631 441.37905884 C24.92914368 441.39061005 25.84907104 441.40216125 26.796875 441.4140625 C27.74564514 441.43342865 28.69441528 441.4527948 29.67193604 441.4727478 C32.69786633 441.53245659 35.72383484 441.57889433 38.75 441.625 C40.80340187 441.66318777 42.85678786 441.70223997 44.91015625 441.7421875 C49.93997496 441.83815108 54.96986865 441.92221446 60 442 C60 442.33 60 442.66 60 443 C46.8 443 33.6 443 20 443 C20 448.61 20 454.22 20 460 C13.4 460 6.8 460 0 460 C0 453.4 0 446.8 0 440 C-6.6 440 -13.2 440 -20 440 C-20 433.4 -20 426.8 -20 420 C-13.4 420 -6.8 420 0 420 C0 413.4 0 406.8 0 400 C-6.6 400 -13.2 400 -20 400 C-20 393.4 -20 386.8 -20 380 C-13.4 380 -6.8 380 0 380 C0 373.4 0 366.8 0 360 C-6.6 360 -13.2 360 -20 360 C-20 353.4 -20 346.8 -20 340 C-13.4 340 -6.8 340 0 340 C0 333.4 0 326.8 0 320 C-6.6 320 -13.2 320 -20 320 C-20 313.4 -20 306.8 -20 300 C-13.4 300 -6.8 300 0 300 C0 293.4 0 286.8 0 280 C-6.6 280 -13.2 280 -20 280 C-20 273.4 -20 266.8 -20 260 C-13.4 260 -6.8 260 0 260 C0 253.4 0 246.8 0 240 C-6.6 240 -13.2 240 -20 240 C-20 233.4 -20 226.8 -20 220 C-13.4 220 -6.8 220 0 220 C0 213.4 0 206.8 0 200 C-6.6 200 -13.2 200 -20 200 C-20 193.4 -20 186.8 -20 180 C-13.4 180 -6.8 180 0 180 C0 173.4 0 166.8 0 160 C-6.6 160 -13.2 160 -20 160 C-20 153.4 -20 146.8 -20 140 C-13.4 140 -6.8 140 0 140 C0 133.4 0 126.8 0 120 C-6.6 120 -13.2 120 -20 120 C-20 113.4 -20 106.8 -20 100 C-13.4 100 -6.8 100 0 100 C0 93.4 0 86.8 0 80 C-6.6 80 -13.2 80 -20 80 C-20 73.4 -20 66.8 -20 60 C-13.4 60 -6.8 60 0 60 C0 53.4 0 46.8 0 40 C-6.6 40 -13.2 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E7E7E7",
    transform: "translate(380,280)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94 0 11.88 0 18 0 C18 6.6 18 13.2 18 20 C24.6 20 31.2 20 38 20 C38 26.6 38 33.2 38 40 C31.4 40 24.8 40 18 40 C18 46.6 18 53.2 18 60 C24.6 60 31.2 60 38 60 C38 66.6 38 73.2 38 80 C31.4 80 24.8 80 18 80 C18 86.6 18 93.2 18 100 C24.6 100 31.2 100 38 100 C38 106.6 38 113.2 38 120 C31.4 120 24.8 120 18 120 C18 126.6 18 133.2 18 140 C24.6 140 31.2 140 38 140 C38 146.6 38 153.2 38 160 C31.4 160 24.8 160 18 160 C18 166.6 18 173.2 18 180 C24.6 180 31.2 180 38 180 C38 186.6 38 193.2 38 200 C31.4 200 24.8 200 18 200 C18 206.6 18 213.2 18 220 C24.6 220 31.2 220 38 220 C38 226.6 38 233.2 38 240 C31.4 240 24.8 240 18 240 C18 246.6 18 253.2 18 260 C24.6 260 31.2 260 38 260 C38 266.6 38 273.2 38 280 C31.4 280 24.8 280 18 280 C18 286.6 18 293.2 18 300 C24.6 300 31.2 300 38 300 C38 306.6 38 313.2 38 320 C31.4 320 24.8 320 18 320 C18 326.6 18 333.2 18 340 C24.6 340 31.2 340 38 340 C38 346.6 38 353.2 38 360 C31.4 360 24.8 360 18 360 C18 366.6 18 373.2 18 380 C24.6 380 31.2 380 38 380 C38 386.6 38 393.2 38 400 C31.4 400 24.8 400 18 400 C18 406.6 18 413.2 18 420 C13.38 420 8.76 420 4 420 C4.97470214 419.01391597 5.94940428 418.02783194 6.95364285 417.01186657 C11.64614287 410.68504392 10.81963471 403.32130881 10.74171448 395.81013489 C10.74648221 394.14861489 10.75387645 392.48710072 10.76366371 390.82560271 C10.78287301 386.26961303 10.76472584 381.71442523 10.74037087 377.15848839 C10.72061435 372.24162469 10.73549067 367.3248494 10.74601746 362.40797424 C10.76113457 352.78055296 10.74423078 343.15344107 10.71646655 333.52605823 C10.68530542 322.31780605 10.68552533 311.10962066 10.68698429 299.90133329 C10.68848587 279.9068945 10.66100751 259.91259972 10.61743164 239.91821289 C10.57515292 220.50900652 10.55392007 201.09992688 10.5559082 181.69067383 C10.55602807 180.49483041 10.55614794 179.29898699 10.55627144 178.06690589 C10.5563925 176.87314461 10.55651357 175.67938332 10.5566383 174.44944745 C10.55870684 152.36032089 10.54104557 130.27124823 10.51417865 108.18213913 C10.5051236 100.36572074 10.50193928 92.54931223 10.50058174 84.73288918 C10.4985371 75.21226471 10.48516749 65.69173112 10.45758332 56.17114524 C10.44371622 51.31182407 10.43459766 46.45261928 10.43836594 41.59327698 C10.44164611 37.14789816 10.43112671 32.70277693 10.40942036 28.25745185 C10.40397169 26.64658553 10.40359797 25.03569268 10.40872223 23.42482529 C10.41490459 21.23993486 10.40274871 19.05589216 10.38590336 16.87107563 C10.38379008 15.65613023 10.38167681 14.44118483 10.3794995 13.18942291 C9.96321031 9.69080889 9.07638084 7.81539693 7 5 C5.2348064 3.60037519 5.2348064 3.60037519 3.3125 2.6875 C2.219375 2.130625 1.12625 1.57375 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#E2E2E2",
    transform: "translate(442,300)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C26.6 20 33.2 20 40 20 C40 26.6 40 33.2 40 40 C46.6 40 53.2 40 60 40 C60 46.6 60 53.2 60 60 C66.6 60 73.2 60 80 60 C80 66.6 80 73.2 80 80 C86.6 80 93.2 80 100 80 C100 86.6 100 93.2 100 100 C106.6 100 113.2 100 120 100 C120 106.6 120 113.2 120 120 C126.6 120 133.2 120 140 120 C140 126.6 140 133.2 140 140 C146.6 140 153.2 140 160 140 C160 143.96 160 147.92 160 152 C166.6 152 173.2 152 180 152 C180 148.04 180 144.08 180 140 C186.6 140 193.2 140 200 140 C200 143.96 200 147.92 200 152 C206.6 152 213.2 152 220 152 C220 148.04 220 144.08 220 140 C226.6 140 233.2 140 240 140 C240 143.96 240 147.92 240 152 C246.6 152 253.2 152 260 152 C260 148.04 260 144.08 260 140 C266.6 140 273.2 140 280 140 C280 144.29 280 148.58 280 153 C215.98 153 151.96 153 86 153 C84.68 149.04 83.36 145.08 82 141 C81.05363193 138.60253423 80.10661989 136.20516694 79.12890625 133.8203125 C77.71088917 130.27772311 76.38880659 126.70271936 75.0625 123.125 C73.32024593 118.43607112 71.52486893 113.79002977 69.5625 109.1875 C66.69733671 102.42534613 64.21820811 95.52906205 61.69921875 88.6328125 C59.88920028 83.68131424 58.02170539 78.75526915 56.10546875 73.84375 C55.40343747 72.03781793 54.71667677 70.22581635 54.05078125 68.40625 C47.04504967 49.72429912 34.70440424 35.78815593 16.72265625 27.125 C12.53609544 25.39511548 8.23807402 24.12764746 3.8828125 22.89453125 C1.40294281 22.12503239 -0.7308066 21.24421957 -3 20 C-2.01 20 -1.02 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(520,20)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C17.504375 20.061875 15.00875 20.12375 12.4375 20.1875 C5.85472943 20.50395394 1.77481369 21.11414413 -3 26 C-5.94635362 30.0233046 -6.37609456 32.87767159 -6.38031673 37.82701683 C-6.38730661 38.84301655 -6.38730661 38.84301655 -6.3944377 39.87954152 C-6.40640793 42.15380824 -6.39698483 44.42747978 -6.38768005 46.70175171 C-6.3918521 48.34687719 -6.39732891 49.99199979 -6.40399987 51.63711703 C-6.4184903 56.16159108 -6.41419854 60.68588353 -6.40683305 65.21036768 C-6.40211254 70.08845907 -6.41460136 74.96651054 -6.42485046 79.84458923 C-6.44206603 89.40280987 -6.44287272 98.96096485 -6.43763756 108.51919697 C-6.43359958 116.28695053 -6.43503499 124.05468466 -6.44038582 131.82243729 C-6.44113424 132.92710791 -6.44188266 134.03177854 -6.44265376 135.16992403 C-6.44418521 137.41391924 -6.44572356 139.65791446 -6.44726873 141.90190966 C-6.46100387 162.95650575 -6.45554907 184.01106471 -6.44408352 205.06565996 C-6.4341511 224.33413217 -6.44709019 243.60250836 -6.47101771 262.87096576 C-6.49539147 282.64751489 -6.50502076 302.42401925 -6.49836498 322.2005831 C-6.4948688 333.30693136 -6.4971311 344.41320577 -6.51461601 355.51954269 C-6.52931648 364.97467227 -6.53000171 374.42967599 -6.5125451 383.88480304 C-6.50401477 388.70996875 -6.50193505 393.53490941 -6.51719666 398.36006355 C-6.53099338 402.77672082 -6.52634547 407.19295919 -6.50695742 411.60959192 C-6.50318163 413.20780552 -6.50616468 414.80605228 -6.51656907 416.40423648 C-6.74779051 427.3976811 -6.74779051 427.3976811 -2 437 C-1.01 438.485 -1.01 438.485 0 440 C-6.6 440 -13.2 440 -20 440 C-20 433.4 -20 426.8 -20 420 C-16.04 420 -12.08 420 -8 420 C-8 413.4 -8 406.8 -8 400 C-11.96 400 -15.92 400 -20 400 C-20 393.4 -20 386.8 -20 380 C-16.04 380 -12.08 380 -8 380 C-8 373.4 -8 366.8 -8 360 C-11.96 360 -15.92 360 -20 360 C-20 353.4 -20 346.8 -20 340 C-16.04 340 -12.08 340 -8 340 C-8 333.4 -8 326.8 -8 320 C-11.96 320 -15.92 320 -20 320 C-20 313.4 -20 306.8 -20 300 C-16.04 300 -12.08 300 -8 300 C-8 293.4 -8 286.8 -8 280 C-11.96 280 -15.92 280 -20 280 C-20 273.4 -20 266.8 -20 260 C-16.04 260 -12.08 260 -8 260 C-8 253.4 -8 246.8 -8 240 C-11.96 240 -15.92 240 -20 240 C-20 233.4 -20 226.8 -20 220 C-16.04 220 -12.08 220 -8 220 C-8 213.4 -8 206.8 -8 200 C-11.96 200 -15.92 200 -20 200 C-20 193.4 -20 186.8 -20 180 C-16.04 180 -12.08 180 -8 180 C-8 173.4 -8 166.8 -8 160 C-11.96 160 -15.92 160 -20 160 C-20 153.4 -20 146.8 -20 140 C-16.04 140 -12.08 140 -8 140 C-8 133.4 -8 126.8 -8 120 C-11.96 120 -15.92 120 -20 120 C-20 113.4 -20 106.8 -20 100 C-16.04 100 -12.08 100 -8 100 C-8 93.4 -8 86.8 -8 80 C-11.96 80 -15.92 80 -20 80 C-20 73.4 -20 66.8 -20 60 C-16.04 60 -12.08 60 -8 60 C-8 53.4 -8 46.8 -8 40 C-11.96 40 -15.92 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(260,280)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.75737295 1.50294918 7.17737211 3.08030058 10.75 4.9375 C25.79861864 12.47097413 40.75469126 13.29923168 57.30537415 13.2784729 C59.13563332 13.28348382 60.96589029 13.28936193 62.79614419 13.29602563 C67.79487818 13.31174332 72.79355584 13.31525175 77.79231155 13.31667423 C83.19433097 13.32038273 88.59632001 13.33554539 93.99832153 13.34928894 C103.34750866 13.37152017 112.69668491 13.3865583 122.04589272 13.39665604 C135.56313343 13.411266 149.08033627 13.43680931 162.59755471 13.46498732 C184.53043983 13.51041324 206.46333043 13.5470454 228.39624023 13.578125 C249.69703237 13.60832775 270.99780812 13.64268595 292.29858398 13.68261719 C294.26935845 13.68630951 294.26935845 13.68630951 296.27994654 13.69007643 C302.87140385 13.70245136 309.462861 13.71490783 316.05431807 13.72740483 C370.70286005 13.83090973 425.35141872 13.92013372 480 14 C480 14.33 480 14.66 480 15 C466.8 15 453.6 15 440 15 C440 21.27 440 27.54 440 34 C433.4 34 426.8 34 420 34 C420 27.73 420 21.46 420 15 C400.2 15 380.4 15 360 15 C360 21.27 360 27.54 360 34 C353.4 34 346.8 34 340 34 C340 27.73 340 21.46 340 15 C320.2 15 300.4 15 280 15 C280 21.27 280 27.54 280 34 C273.4 34 266.8 34 260 34 C260 27.73 260 21.46 260 15 C240.2 15 220.4 15 200 15 C200 21.27 200 27.54 200 34 C193.4 34 186.8 34 180 34 C180 27.73 180 21.46 180 15 C160.2 15 140.4 15 120 15 C120 21.27 120 27.54 120 34 C113.4 34 106.8 34 100 34 C100 27.73 100 21.46 100 15 C80.2 15 60.4 15 40 15 C40 21.27 40 27.54 40 34 C33.4 34 26.8 34 20 34 C20 27.4 20 20.8 20 14 C13.4 14 6.8 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(160,826)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C26.6 19 33.2 19 40 19 C40 12.73 40 6.46 40 0 C46.6 0 53.2 0 60 0 C60 6.27 60 12.54 60 19 C66.6 19 73.2 19 80 19 C80 12.73 80 6.46 80 0 C86.6 0 93.2 0 100 0 C100 6.27 100 12.54 100 19 C106.6 19 113.2 19 120 19 C120 12.73 120 6.46 120 0 C126.6 0 133.2 0 140 0 C140 6.27 140 12.54 140 19 C146.6 19 153.2 19 160 19 C160 12.73 160 6.46 160 0 C166.6 0 173.2 0 180 0 C180 6.6 180 13.2 180 20 C176.72922798 20.01213028 176.72922798 20.01213028 173.39237976 20.02450562 C152.83729583 20.10166892 132.28227838 20.18964353 111.72728252 20.28752708 C101.15991848 20.3375903 90.59256195 20.38403385 80.02514648 20.421875 C70.81164715 20.45487714 61.59820722 20.49475354 52.38477355 20.54279006 C47.50902283 20.56797344 42.63331109 20.5897786 37.75751305 20.60334396 C33.16188533 20.61623866 28.56639189 20.63837192 23.97083855 20.66738319 C22.29035144 20.67640135 20.60984275 20.68213562 18.92933273 20.68421364 C7.40896677 20.70100016 -3.40150893 21.21782085 -14.1875 25.625 C-15.29480469 26.07101563 -16.40210938 26.51703125 -17.54296875 26.9765625 C-18.35378906 27.31429687 -19.16460937 27.65203125 -20 28 C-20 25.36 -20 22.72 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(320,20)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.62 0 9.24 0 14 C6.6 14 13.2 14 20 14 C20 20.6 20 27.2 20 34 C13.4 34 6.8 34 0 34 C0 40.6 0 47.2 0 54 C-6.6 54 -13.2 54 -20 54 C-20 47.4 -20 40.8 -20 34 C-26.6 34 -33.2 34 -40 34 C-40 27.4 -40 20.8 -40 14 C-33.4 14 -26.8 14 -20 14 C-20 9.71 -20 5.42 -20 1 C-13.32473613 -0.24190956 -6.78133093 -0.06991063 0 0 Z ",
    fill: "#F5F5F5",
    transform: "translate(360,106)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C4.96 7 8.92 7 13 7 C13 13.6 13 20.2 13 27 C9.04 27 5.08 27 1 27 C1 86.4 1 145.8 1 207 C4.96 207 8.92 207 13 207 C13 213.6 13 220.2 13 227 C9.04 227 5.08 227 1 227 C1 233.6 1 240.2 1 247 C4.96 247 8.92 247 13 247 C13 253.6 13 260.2 13 267 C9.04 267 5.08 267 1 267 C1 273.6 1 280.2 1 287 C4.96 287 8.92 287 13 287 C13 293.6 13 300.2 13 307 C9.04 307 5.08 307 1 307 C1 313.6 1 320.2 1 327 C4.96 327 8.92 327 13 327 C13 333.6 13 340.2 13 347 C9.04 347 5.08 347 1 347 C1 353.6 1 360.2 1 367 C4.96 367 8.92 367 13 367 C13 373.6 13 380.2 13 387 C9.04 387 5.08 387 1 387 C1 389.64 1 392.28 1 395 C0.67 395 0.34 395 0 395 C0 264.65 0 134.3 0 0 Z ",
    fill: "#E8E8E8",
    transform: "translate(587,313)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.99 0.495 0.99 1 2 C5.29 2 9.58 2 14 2 C14 8.6 14 15.2 14 22 C7.4 22 0.8 22 -6 22 C-6 28.6 -6 35.2 -6 42 C-12.6 42 -19.2 42 -26 42 C-26 48.6 -26 55.2 -26 62 C-32.6 62 -39.2 62 -46 62 C-46 55.4 -46 48.8 -46 42 C-52.6 42 -59.2 42 -66 42 C-66 41.67 -66 41.34 -66 41 C-64.79085937 40.78085937 -63.58171875 40.56171875 -62.3359375 40.3359375 C-38.17565519 35.74719349 -17.32781846 24.54821026 -2.68359375 4.16796875 C-1.7618291 2.79656281 -0.87576681 1.4012269 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(706,798)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.5575 0.04125 5.115 0.0825 7.75 0.125 C7.75 6.725 7.75 13.325 7.75 20.125 C1.15 20.125 -5.45 20.125 -12.25 20.125 C-12.25 26.725 -12.25 33.325 -12.25 40.125 C-18.85 40.125 -25.45 40.125 -32.25 40.125 C-32.25 33.525 -32.25 26.925 -32.25 20.125 C-38.85 20.125 -45.45 20.125 -52.25 20.125 C-52.25 14.515 -52.25 8.905 -52.25 3.125 C-50.46384277 3.095271 -50.46384277 3.095271 -48.64160156 3.06494141 C-44.22081468 2.98883005 -39.80035457 2.90012106 -35.37988281 2.80761719 C-33.46718805 2.76935032 -31.55442189 2.73449342 -29.64160156 2.703125 C-26.89101658 2.65742473 -24.14092217 2.59943855 -21.390625 2.5390625 C-20.53631897 2.52751129 -19.68201294 2.51596008 -18.80181885 2.50405884 C-18.00129089 2.48418915 -17.20076294 2.46431946 -16.37597656 2.44384766 C-15.67426331 2.43052399 -14.97255005 2.41720032 -14.24957275 2.4034729 C-12.17907611 2.22373431 -12.17907611 2.22373431 -10.23529053 1.11727905 C-6.99701512 -0.50126131 -3.5382875 -0.0806427 0 0 Z ",
    fill: "#F6F6F6",
    transform: "translate(452.25,719.875)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C26.6 12 33.2 12 40 12 C40 8.04 40 4.08 40 0 C46.6 0 53.2 0 60 0 C60 3.96 60 7.92 60 12 C66.6 12 73.2 12 80 12 C80 8.04 80 4.08 80 0 C86.6 0 93.2 0 100 0 C100 3.96 100 7.92 100 12 C106.6 12 113.2 12 120 12 C120 8.04 120 4.08 120 0 C126.6 0 133.2 0 140 0 C140 3.96 140 7.92 140 12 C146.6 12 153.2 12 160 12 C160 8.04 160 4.08 160 0 C165.94 0 171.88 0 178 0 C174.125 11.875 174.125 11.875 173 13 C170.77241743 13.09703132 168.54169074 13.12186673 166.31199646 13.12025452 C165.60468748 13.12110894 164.89737849 13.12196337 164.1686359 13.12284368 C161.78093718 13.12450055 159.39330757 13.11897377 157.00561523 13.11352539 C155.30105593 13.11324354 153.59649649 13.11340122 151.89193726 13.1139679 C147.249572 13.11425594 142.60723235 13.10835806 137.96487308 13.10139394 C133.11884105 13.09516159 128.27280849 13.0945567 123.42677307 13.09336853 C114.24344036 13.09025486 105.0601195 13.082041 95.87679201 13.07201904 C85.42473229 13.060859 74.97267202 13.05534773 64.52060783 13.05032361 C43.01373193 13.03985841 21.50686671 13.02225829 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(60,160)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.00097681 1.10171577 1.00195362 2.20343153 1.00296003 3.33853263 C1.04621489 51.90341767 1.09317484 100.46829721 1.15898132 149.03315735 C1.16047467 150.13640434 1.16047467 150.13640434 1.16199819 151.26193914 C1.18365781 167.24711975 1.20598059 183.23229936 1.22898628 199.21747808 C1.24026459 207.05685045 1.25139638 214.89622302 1.26245117 222.7355957 C1.26410502 223.90574999 1.26410502 223.90574999 1.26579228 225.09954377 C1.3014471 250.37511803 1.32743157 275.65069098 1.34838969 300.92628135 C1.36998191 326.90490174 1.40135316 352.88349247 1.44499113 378.86208563 C1.45115318 382.53319235 1.45720369 386.20429925 1.46318626 389.87540627 C1.46436715 390.59791747 1.46554803 391.32042867 1.46676469 392.06483415 C1.4854705 403.68518123 1.49389817 415.30551402 1.49846124 426.92587431 C1.50327117 438.61437417 1.51919981 450.3028109 1.54566566 461.9912829 C1.55967605 468.32187597 1.56885312 474.65237882 1.56500816 480.98298836 C1.56159269 486.78235453 1.57199332 492.58152818 1.59323552 498.38085494 C1.59849463 500.47527842 1.59874757 502.56972195 1.59339563 504.66414519 C1.56027393 519.10002796 2.67298212 531.59022523 8.5 545 C8.79519531 545.71027344 9.09039062 546.42054688 9.39453125 547.15234375 C11.00948021 550.97272963 12.85558205 554.44340438 15 558 C15 558.66 15 559.32 15 560 C10.38 560 5.76 560 1 560 C1 553.4 1 546.8 1 540 C-5.6 540 -12.2 540 -19 540 C-19 533.4 -19 526.8 -19 520 C-12.73 520 -6.46 520 0 520 C0 348.4 0 176.8 0 0 Z ",
    fill: "#D4D4D4",
    transform: "translate(119,240)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C26.6 20 33.2 20 40 20 C40 26.6 40 33.2 40 40 C46.6 40 53.2 40 60 40 C60 46.6 60 53.2 60 60 C55.545 60.495 55.545 60.495 51 61 C50.41605469 59.89205078 50.41605469 59.89205078 49.8203125 58.76171875 C40.18399319 41.28756368 26.2549138 29.62628386 7.125 23.8125 C5.52011719 23.35810547 5.52011719 23.35810547 3.8828125 22.89453125 C1.40294281 22.12503239 -0.7308066 21.24421957 -3 20 C-2.01 20 -1.02 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EAEAEA",
    transform: "translate(520,20)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94067917 -0.12441814 11.88058531 -0.21472356 17.82226562 -0.2746582 C19.83965278 -0.2996658 21.85695059 -0.3336834 23.87402344 -0.37719727 C46.68912076 -0.85674308 46.68912076 -0.85674308 56.125 7.625 C58 10 58 10 58 13 C52.06 13 46.12 13 40 13 C40 19.6 40 26.2 40 33 C33.4 33 26.8 33 20 33 C20 26.4 20 19.8 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,107)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.6 1 13.2 1 20 C7.6 20 14.2 20 21 20 C21 26.6 21 33.2 21 40 C14.4 40 7.8 40 1 40 C1 44.29 1 48.58 1 53 C-5.93 53 -12.86 53 -20 53 C-19.27814171 47.94699197 -18.77228579 44.87924393 -16.92578125 40.41015625 C-16.50820557 39.38567383 -16.09062988 38.36119141 -15.66040039 37.30566406 C-15.21559326 36.23541992 -14.77078613 35.16517578 -14.3125 34.0625 C-13.3995584 31.83003307 -12.48809972 29.59695915 -11.578125 27.36328125 C-11.13533203 26.27869629 -10.69253906 25.19411133 -10.23632812 24.07666016 C-8.11588052 18.79982748 -6.17733271 13.46051966 -4.25390625 8.109375 C-3.07097647 5.17600396 -1.76774581 2.61961218 0 0 Z ",
    fill: "#F1F1F1",
    transform: "translate(319,120)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.49088155 -0.00079234 2.98176289 -0.00289407 4.47264099 -0.00619507 C8.49301772 -0.01129588 12.5131352 0.00213726 16.53347039 0.01933193 C20.75116324 0.03444598 24.96885382 0.03319566 29.18656921 0.03399658 C36.26179389 0.03767947 43.33692098 0.05260109 50.41210938 0.07519531 C59.48922346 0.10412384 68.56625931 0.11442574 77.6434145 0.11887741 C85.46051161 0.12285856 93.27759179 0.13535481 101.09467673 0.14922428 C103.60251372 0.15331748 106.1103501 0.1562459 108.61818886 0.15901947 C112.55726367 0.16391965 116.49629132 0.17413516 120.43534279 0.18845749 C121.87971063 0.19297122 123.3240848 0.19581696 124.76845932 0.19686508 C126.74114164 0.19861761 128.71381446 0.20714356 130.68647766 0.21600342 C132.34143234 0.22046541 132.34143234 0.22046541 134.02982044 0.22501755 C136.79369194 0.34768945 139.30138104 0.72909303 141.9909668 1.35644531 C141.9909668 1.68644531 141.9909668 2.01644531 141.9909668 2.35644531 C128.7909668 2.35644531 115.5909668 2.35644531 101.9909668 2.35644531 C101.9909668 6.64644531 101.9909668 10.93644531 101.9909668 15.35644531 C95.3909668 15.35644531 88.7909668 15.35644531 81.9909668 15.35644531 C81.9909668 11.06644531 81.9909668 6.77644531 81.9909668 2.35644531 C62.1909668 2.35644531 42.3909668 2.35644531 21.9909668 2.35644531 C21.9909668 6.64644531 21.9909668 10.93644531 21.9909668 15.35644531 C15.3909668 15.35644531 8.7909668 15.35644531 1.9909668 15.35644531 C1.9909668 10.73644531 1.9909668 6.11644531 1.9909668 1.35644531 C-7.9090332 1.85144531 -7.9090332 1.85144531 -18.0090332 2.35644531 C-18.0090332 6.64644531 -18.0090332 10.93644531 -18.0090332 15.35644531 C-24.6090332 15.35644531 -31.2090332 15.35644531 -38.0090332 15.35644531 C-26.47976403 1.90563127 -17.29287129 -0.11915169 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(358.009033203125,104.6435546875)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.77668533 0.00703949 1.55337067 0.01407898 2.35359192 0.02133179 C3.58682442 0.04075081 3.58682442 0.04075081 4.8449707 0.06056213 C5.73371384 0.07016968 6.62245697 0.07977722 7.53813171 0.0896759 C10.44909217 0.12241688 13.3598906 0.16284246 16.27075195 0.2033844 C18.2995549 0.22770991 20.32836368 0.25155222 22.35717773 0.27493286 C27.67709044 0.33753196 32.99689863 0.40666615 38.31671143 0.47718811 C43.75316642 0.54809088 49.18969506 0.6127762 54.6262207 0.67799377 C65.27864773 0.80669421 75.93095974 0.94287764 86.58325195 1.08229065 C86.58325195 7.68229065 86.58325195 14.28229065 86.58325195 21.08229065 C80.31325195 21.08229065 74.04325195 21.08229065 67.58325195 21.08229065 C67.58325195 14.81229065 67.58325195 8.54229065 67.58325195 2.08229065 C47.78325195 2.08229065 27.98325195 2.08229065 7.58325195 2.08229065 C7.58325195 8.35229065 7.58325195 14.62229065 7.58325195 21.08229065 C0.98325195 21.08229065 -5.61674805 21.08229065 -12.41674805 21.08229065 C-12.41674805 14.48229065 -12.41674805 7.88229065 -12.41674805 1.08229065 C-3.41674805 -0.04270935 -3.41674805 -0.04270935 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(32.416748046875,238.91770935058594)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 127.71 1 255.42 1 387 C7.27 387 13.54 387 20 387 C20 393.6 20 400.2 20 407 C11.75 407 3.5 407 -5 407 C-2 400 -2 400 -1 398 C-0.89962594 395.84790719 -0.86607427 393.6926179 -0.8613348 391.53819084 C-0.85849258 390.86391043 -0.85565036 390.18963001 -0.85272202 389.49491686 C-0.84433493 387.2132231 -0.84310368 384.93157985 -0.84178162 382.64987183 C-0.83721899 381.00647393 -0.83221942 379.36307721 -0.82681805 377.71968186 C-0.81319339 373.18637673 -0.80580611 368.65307913 -0.79939139 364.11975884 C-0.79140639 359.23766712 -0.77770211 354.35559116 -0.76467896 349.47351074 C-0.74288916 341.0091997 -0.72475386 332.54488708 -0.70907402 324.08056259 C-0.68639814 311.84244609 -0.65825218 299.60434702 -0.62875474 287.36624528 C-0.5810508 267.51256314 -0.53779423 247.65887387 -0.49731445 227.80517578 C-0.45797377 208.51480556 -0.41655098 189.22444167 -0.37231445 169.93408203 C-0.36959018 168.74578324 -0.36686591 167.55748445 -0.36405908 166.3331766 C-0.35037984 160.37205743 -0.33665952 154.41093835 -0.32291877 148.44981933 C-0.20890998 98.96655941 -0.10211039 49.4832858 0 0 Z ",
    fill: "#D7D7D7",
    transform: "translate(320,313)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19.33 2.97 19.66 5.94 20 9 C22.0210456 13.95156171 25.35702371 18.31739148 30 21 C33.33047668 21.89154299 36.58535552 22.45365688 40 23 C40 28.61 40 34.22 40 40 C33.4 40 26.8 40 20 40 C20 33.4 20 26.8 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,700)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.09175799 4.74060227 7.4922142 9.90307964 9.8125 16.375 C12.33605973 23.27449411 15.02094777 30.0906124 17.80078125 36.890625 C18.72099923 39.27659736 19.47533152 41.5062816 20 44 C19.34 44 18.68 44 18 44 C18 43.34 18 42.68 18 42 C12.72 42 7.44 42 2 42 C2 35.4 2 28.8 2 22 C-4.6 22 -11.2 22 -18 22 C-18 15.4 -18 8.8 -18 2 C-12.06 2 -6.12 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(518,118)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.99 0.495 0.99 1 2 C2.32 2.33 3.64 2.66 5 3 C5 9.6 5 16.2 5 23 C-1.6 23 -8.2 23 -15 23 C-15 17.39 -15 11.78 -15 6 C-21.6 6 -28.2 6 -35 6 C-35 11.61 -35 17.22 -35 23 C-41.6 23 -48.2 23 -55 23 C-55 16.4 -55 9.8 -55 3 C-53.68 3.33 -52.36 3.66 -51 4 C-49.46983354 4.10265538 -47.93607586 4.15797073 -46.40258789 4.17700195 C-45.04581688 4.19625481 -45.04581688 4.19625481 -43.66163635 4.21589661 C-42.2068412 4.22697701 -42.2068412 4.22697701 -40.72265625 4.23828125 C-39.21740639 4.25038887 -39.21740639 4.25038887 -37.68174744 4.26274109 C-35.56104245 4.2765576 -33.44031545 4.28729061 -31.31958008 4.29516602 C-28.07786154 4.31241825 -24.83715278 4.35633113 -21.59570312 4.40039062 C-19.53386165 4.41051472 -17.47201153 4.41903171 -15.41015625 4.42578125 C-14.44231705 4.44328934 -13.47447784 4.46079742 -12.47731018 4.47883606 C-8.01941589 4.46446748 -5.67846914 4.43641785 -1.84936523 1.97338867 C-1.23907471 1.32217041 -0.62878418 0.67095215 0 0 Z ",
    fill: "#EAEAEA",
    transform: "translate(315,717)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C9.04 20 5.08 20 1 20 C1.33 182.69 1.66 345.38 2 513 C-0.5677252 510.4322748 -0.24067151 508.74179264 -0.26201695 505.24181128 C-0.25676292 504.42724478 -0.2515089 503.61267829 -0.24609566 502.77342796 C-0.24840335 501.90836132 -0.25071103 501.04329468 -0.25308865 500.1520139 C-0.25842887 497.22125226 -0.2493714 494.29070555 -0.24050903 491.35995483 C-0.24138028 489.25045521 -0.24312976 487.1409558 -0.24568737 485.03145754 C-0.25018083 479.20974462 -0.24212989 473.38810463 -0.23213124 467.566401 C-0.22352769 461.29780223 -0.2264147 455.02920787 -0.22793579 448.76060486 C-0.22898661 437.89153207 -0.22275899 427.02248876 -0.21146011 416.15342331 C-0.19963678 404.7506944 -0.19193039 393.34797502 -0.18975449 381.94524002 C-0.18961701 381.2369543 -0.18947953 380.52866857 -0.18933788 379.79891964 C-0.18866124 376.20207462 -0.18805846 372.60522958 -0.18748413 369.00838454 C-0.18328035 343.51437225 -0.16979738 318.02037244 -0.15087891 292.52636719 C-0.13251802 267.75520901 -0.11834689 242.98405424 -0.10986328 218.21289062 C-0.10960023 217.44969111 -0.10933718 216.68649159 -0.10906615 215.90016481 C-0.10642917 208.23598671 -0.10387754 200.57180859 -0.10138843 192.90763045 C-0.09631565 177.29402111 -0.09067314 161.68041199 -0.08468628 146.06680298 C-0.0844117 145.34887272 -0.08413712 144.63094246 -0.08385422 143.89125674 C-0.06544466 95.92749919 -0.03371179 47.96374898 0 0 Z ",
    fill: "#DFDFDF",
    transform: "translate(187,240)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C17.463125 13.3403125 17.463125 13.3403125 14.875 13.6875 C9.42864425 14.67583483 6.75260387 15.9587343 3 20 C0.42131637 23.77133878 0.65232575 27.85853319 0.5859375 32.265625 C0.56657135 33.05902283 0.5472052 33.85242065 0.5272522 34.66986084 C0.46761639 37.19646557 0.42113557 39.72311625 0.375 42.25 C0.33680545 43.96616537 0.29775285 45.68231187 0.2578125 47.3984375 C0.16192814 51.59880456 0.07783833 55.79926134 0 60 C-0.33 60 -0.66 60 -1 60 C-1 53.4 -1 46.8 -1 40 C-7.27 40 -13.54 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EBEBEB",
    transform: "translate(20,160)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 2.64 20 5.28 20 8 C17.4375 10.46875 17.4375 10.46875 14 12.5 C12.79435361 13.2582774 11.5925135 14.02264 10.39453125 14.79296875 C9.51595459 15.35056885 9.51595459 15.35056885 8.61962891 15.91943359 C0.57081413 21.28935434 -6.95227367 30.85682102 -10 40 C-13.3 40 -16.6 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FBFBFB",
    transform: "translate(280,40)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13.77183386 8.74745043 11.8603063 14.67342362 7 22 C1.85522182 27.88271606 -3.69777916 30.56592639 -11 33 C-12.56118428 33.06740865 -14.1250252 33.08514456 -15.6875 33.0625 C-17.110625 33.041875 -18.53375 33.02125 -20 33 C-20 28.71 -20 24.42 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EAEAEA",
    transform: "translate(640,740)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C7.02514669 6.05661698 4.8967421 12.01102947 2.5625 17.9375 C2.25610596 18.72165283 1.94971191 19.50580566 1.6340332 20.3137207 C0.01462586 24.45068329 -1.63428808 28.57398807 -3.3125 32.6875 C-4.81504984 36.40840668 -5.98725652 40.11781667 -7 44 C-7.33 42.68 -7.66 41.36 -8 40 C-11.96 40 -15.92 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E9E9E9",
    transform: "translate(260,80)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C19.8 0 39.6 0 60 0 C60 0.33 60 0.66 60 1 C46.8 1 33.6 1 20 1 C20 7.27 20 13.54 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(740,240)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C12.74729122 20.74175431 7.36091337 20.92011417 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(300,280)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,860)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,860)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(780,860)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,860)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(740,860)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,860)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(700,860)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,860)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(660,860)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,860)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(620,860)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,860)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(580,860)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,860)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(540,860)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(520,860)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(500,860)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,860)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(460,860)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,860)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(420,860)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,860)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(380,860)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,860)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(340,860)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,860)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(300,860)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,860)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(260,860)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,860)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(220,860)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,860)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(180,860)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,860)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(140,860)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,860)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(100,860)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,860)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(60,860)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,860)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(20,860)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,860)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,840)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,840)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,840)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,840)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,840)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,840)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,840)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,840)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,840)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,840)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,840)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,840)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,840)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,840)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,840)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,840)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,820)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,820)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,820)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,820)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,820)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,820)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,820)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,820)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,820)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,820)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,820)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,820)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,820)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,800)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,800)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,800)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,800)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,800)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,800)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,800)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,800)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,800)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,800)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,800)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,800)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,780)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,780)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,780)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,780)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,780)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,780)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,780)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,780)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,780)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,780)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,780)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,760)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,760)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,760)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,760)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,760)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,760)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,760)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,760)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,760)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,760)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,760)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,740)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,740)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,740)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,740)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,740)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,740)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,740)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,740)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(540,740)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(520,740)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,740)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,740)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,740)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,740)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,740)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,740)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,740)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,740)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,740)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(260,740)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,740)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,740)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,740)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,740)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,740)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,740)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,720)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,720)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,720)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,720)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,720)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,720)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,720)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,720)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,720)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,720)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,720)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(240,720)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,720)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,720)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,720)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,720)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,720)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,720)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,720)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,700)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,700)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,700)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,700)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,700)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,700)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,700)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,700)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,700)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,700)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,700)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,700)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,700)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,700)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,700)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,680)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,680)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,680)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,680)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,680)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,680)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,680)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,680)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,680)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,680)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,680)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,680)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,680)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,680)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,680)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,660)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,660)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,660)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,660)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,660)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,660)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,660)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,660)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,660)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,660)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,660)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,660)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,660)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,660)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,660)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,640)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,640)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,640)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,640)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,640)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,640)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,640)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,640)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,640)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,640)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,640)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,640)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,640)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,640)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,640)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,620)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,620)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,620)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,620)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,620)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,620)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,620)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,620)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,620)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,620)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,620)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,620)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,620)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,620)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,620)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,600)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,600)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,600)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,600)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,600)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,600)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,600)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,600)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,600)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,600)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,600)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,600)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,600)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,600)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,600)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,580)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,580)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,580)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,580)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,580)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,580)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,580)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,580)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,580)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,580)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,580)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,580)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,580)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,580)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,580)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,560)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,560)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,560)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,560)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,560)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,560)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,560)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,560)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,560)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,560)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,560)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,560)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,560)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,560)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,560)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,540)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,540)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,540)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,540)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,540)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,540)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,540)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,540)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,540)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,540)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,540)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,540)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,540)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,540)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,540)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,520)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,520)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,520)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,520)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,520)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,520)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,520)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,520)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,520)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,520)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,520)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,520)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,520)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,520)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,520)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,500)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,500)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,500)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,500)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,500)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,500)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,500)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,500)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,500)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,500)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,500)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,500)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,500)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,500)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,500)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,500)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,480)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,480)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,480)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,480)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,480)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,480)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,480)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,480)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,480)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,480)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,480)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,480)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,480)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,480)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,480)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,480)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,460)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,460)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,460)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,460)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,460)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,460)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,460)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,460)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,460)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,460)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,460)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,460)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,460)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,460)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,460)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,460)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,440)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,440)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,440)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,440)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,440)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,440)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,440)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,440)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,440)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,440)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,440)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,440)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,440)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,440)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,440)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,440)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,420)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,420)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,420)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,420)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,420)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,420)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,420)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,420)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,420)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,420)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,420)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,420)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,420)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,420)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,420)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,420)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,400)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,400)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,400)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,400)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,400)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,400)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,400)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,400)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,400)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,400)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,400)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,400)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,400)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,400)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,400)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,400)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,400)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,380)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,380)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,380)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,380)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,380)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,380)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,380)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,380)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,380)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,380)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,380)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,380)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,380)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,380)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,380)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,380)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,360)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,360)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,360)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,360)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,360)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,360)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,360)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,360)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,360)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,360)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,360)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,360)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,360)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,360)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,360)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,360)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,360)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,340)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,340)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,340)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,340)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,340)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,340)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,340)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,340)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,340)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,340)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,340)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,340)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,340)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,340)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,340)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,320)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,320)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,320)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,320)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,320)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,320)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,320)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,320)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,320)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,320)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,320)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,320)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,320)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,320)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,320)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,320)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,300)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,300)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,300)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,300)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,300)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,300)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,300)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,300)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,300)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,300)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,300)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,300)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,300)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,300)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,300)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,300)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,300)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,280)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,280)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,280)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,280)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,280)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,280)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,280)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(540,280)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,280)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,280)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,280)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(440,280)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(420,280)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,280)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,280)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,280)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,280)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,280)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,280)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,280)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,280)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,280)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,280)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,280)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,280)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,280)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,260)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,260)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,260)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,260)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,260)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,260)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,260)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(540,260)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(520,260)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,260)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,260)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,260)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,260)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,260)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,260)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,260)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,260)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,260)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,260)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,260)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,260)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,260)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,260)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,240)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,240)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,240)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,240)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(820,200)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,160)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,160)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,140)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,140)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,140)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,140)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,140)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,140)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,140)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,140)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,140)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,140)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,140)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(420,140)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,140)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,140)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,140)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,140)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,140)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,140)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,140)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,140)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,140)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,120)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,120)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,120)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,120)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,120)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,120)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,120)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,120)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,120)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,120)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,120)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,120)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,120)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,120)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(440,120)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(420,120)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,120)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,120)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,120)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,120)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,120)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,120)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,120)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,120)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,120)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,120)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,120)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,120)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,120)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,120)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,120)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,120)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,100)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,100)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,100)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,100)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,100)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,100)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,100)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,100)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,100)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,100)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,100)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,100)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,100)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,100)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,100)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,100)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,100)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,100)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,100)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,100)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,100)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,100)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,100)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,100)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,80)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,80)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,80)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,80)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,80)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,80)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,80)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,80)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,80)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,80)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,80)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,80)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(240,80)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,80)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,80)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,80)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,80)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,80)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,80)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,80)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,80)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,80)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,80)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,80)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,80)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,60)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,60)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,60)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,60)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,60)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,60)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,60)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,60)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,60)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,60)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,60)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,60)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,60)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,60)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,60)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,60)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,60)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,60)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,60)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,60)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,60)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,60)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,60)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,60)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,60)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,60)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,40)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,40)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,40)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,40)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,40)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,40)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,40)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,40)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,40)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,40)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,40)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,40)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,40)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(560,40)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,40)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,40)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,40)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,40)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,40)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,40)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,40)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,40)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,40)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,40)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,40)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,40)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,40)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,40)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,20)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,20)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,20)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,20)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,20)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,20)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,20)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,20)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,20)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,20)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,20)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,20)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,20)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,20)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(540,20)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,20)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,20)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,20)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(260,20)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,20)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,20)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,20)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,20)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,20)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,20)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,20)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,20)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,20)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,20)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,20)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,20)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,20)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(800,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(760,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(720,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(680,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(640,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(600,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(560,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(540,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(520,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(480,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(440,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(400,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(360,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(320,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(280,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(240,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(200,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(160,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(120,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(80,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(40,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.83625 0.061875 3.83625 0.061875 7.75 0.125 C7.75 6.725 7.75 13.325 7.75 20.125 C1.15 20.125 -5.45 20.125 -12.25 20.125 C-12.25 14.185 -12.25 8.245 -12.25 2.125 C-7.87319385 -0.06340308 -4.72549717 -0.10770092 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(452.25,719.875)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.4 20 5.8 20 -1 20 C-0.67 13.4 -0.34 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,740)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,841)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(560,841)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(520,841)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,841)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(440,841)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,841)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,841)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,841)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,841)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,841)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,841)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,740)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C13.2 0 26.4 0 40 0 C40 0.33 40 0.66 40 1 C35.71 1 31.42 1 27 1 C27 6.61 27 12.22 27 18 C20.4 18 13.8 18 7 18 C7 12.39 7 6.78 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#E9E9E9",
    transform: "translate(533,722)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,720)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,720)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,700)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,700)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,680)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,680)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,680)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,680)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,660)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,660)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,660)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,660)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,640)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,640)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,640)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,640)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,620)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,620)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,620)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,620)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,600)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,600)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,600)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,600)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,580)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,580)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,580)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,580)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,560)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,560)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,560)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,560)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,540)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,540)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,540)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,540)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,520)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,520)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,520)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,520)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,500)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,500)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,500)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,500)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,480)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,480)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,480)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,480)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,460)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,460)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,460)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,460)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,440)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,440)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,440)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,440)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,420)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,420)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,420)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,420)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,400)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,400)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,400)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,400)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,380)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,380)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,380)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,380)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,360)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,360)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,360)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,360)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,340)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,340)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(321,340)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,340)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,320)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,320)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(321,320)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,320)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(721,300)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,300)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,280)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,280)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,260)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,241)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(721,240)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,241)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(560,241)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(520,241)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,241)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(440,241)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,241)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,241)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,241)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,241)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,241)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,241)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,241)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,200)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,20)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(420,20)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,20)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,20)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C14.55103899 -0.75005356 14.55103899 -0.75005356 18.8984375 2.890625 C21.52667876 7.92342741 20.32900698 14.59488529 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,820)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 6.27 0 12.54 0 19 C-6.6 19 -13.2 19 -20 19 C-20 13.39 -20 7.78 -20 2 C-16.6796875 1.77213542 -13.359375 1.54427083 -10.0390625 1.31640625 C-6.04597637 0.90067363 -4.3300781 0 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,721)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C15.71 20 11.42 20 7 20 C0 6.36842105 0 6.36842105 0 0 Z ",
    fill: "#FBFBFB",
    transform: "translate(580,100)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 5.61 20 11.22 20 17 C13.4 17 6.8 17 0 17 C0 11.39 0 5.78 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,723)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 5.61 20 11.22 20 17 C13.4 17 6.8 17 0 17 C0 11.39 0 5.78 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,723)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.49899275 0.00084778 2.99798673 0.0003682 4.49697876 -0.00132751 C8.53769118 -0.00218303 12.57813268 0.01537015 16.61878252 0.03639436 C20.85215385 0.05523577 25.08553241 0.05691745 29.31893921 0.06047058 C37.32267424 0.06976923 45.32628533 0.09435327 53.32996595 0.12451905 C62.44729827 0.15813121 71.56463673 0.17456616 80.68201566 0.18960536 C99.42528755 0.22090493 118.16844433 0.2736227 136.91162109 0.34057617 C136.91162109 0.67057617 136.91162109 1.00057617 136.91162109 1.34057617 C85.76162109 1.67057617 34.61162109 2.00057617 -18.08837891 2.34057617 C-18.08837891 6.63057617 -18.08837891 10.92057617 -18.08837891 15.34057617 C-24.68837891 15.34057617 -31.28837891 15.34057617 -38.08837891 15.34057617 C-26.53239917 1.85859981 -17.33184241 -0.13831513 0 0 Z ",
    fill: "#BABABA",
    transform: "translate(358.08837890625,104.659423828125)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C5.73 20 -0.54 20 -7 20 C-5 16 -5 16 -3.96484375 14.140625 C-1.36156416 9.34979869 -0.38841518 5.4378125 0 0 Z ",
    fill: "#FBFBFB",
    transform: "translate(588,700)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.88301889 2.88301889 3.67338087 6.46082678 4.9375 10.25 C6.66002625 15.38674069 8.54169672 20.15677562 11 25 C11 25.66 11 26.32 11 27 C10.34 27 9.68 27 9 27 C9 26.34 9 25.68 9 25 C3.72 25 -1.56 25 -7 25 C-7 18.4 -7 11.8 -7 5 C-3.535 4.505 -3.535 4.505 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#E4E4E4",
    transform: "translate(527,135)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.62 0 9.24 0 14 C-6.6 14 -13.2 14 -20 14 C-20 9.71 -20 5.42 -20 1 C-13.32473613 -0.24190956 -6.78133093 -0.06991063 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,106)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C10.1 13 0.2 13 -10 13 C-10 12.67 -10 12.34 -10 12 C-6.7 12 -3.4 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(220,760)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,760)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(580,760)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(560,760)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(540,760)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(520,760)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(500,760)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,760)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(460,760)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(440,760)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(420,760)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,760)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,760)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,760)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(340,760)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,760)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(300,760)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,760)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(260,760)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,760)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,720)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,700)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,680)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,660)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,640)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,620)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,600)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,580)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,560)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,540)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,520)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,500)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,480)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,460)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,440)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,420)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,400)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,380)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,360)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,340)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,320)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,300)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,280)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(640,260)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C8.71 20 4.42 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FCFCFC",
    transform: "translate(640,240)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,160)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,160)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C5.95 4 10.9 4 16 4 C16 8.29 16 12.58 16 17 C9.07 17 2.14 17 -5 17 C-4.28400038 11.98800263 -3.80796094 8.96713382 -1.9375 4.5625 C-1.57527344 3.69753906 -1.21304687 2.83257812 -0.83984375 1.94140625 C-0.56269531 1.30074219 -0.28554688 0.66007813 0 0 Z ",
    fill: "#E7E7E7",
    transform: "translate(304,156)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,160)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,107)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(420,107)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.29 20 8.58 20 13 C13.4 13 6.8 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,107)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,720)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,700)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,680)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,680)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,660)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,660)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,640)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,640)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,620)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,620)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,600)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,600)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,580)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,580)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(588,560)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,560)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,560)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,540)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,540)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(588,520)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,520)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,520)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,500)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,500)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(588,480)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,480)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,480)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,460)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,460)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(588,440)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,440)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,440)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,420)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,420)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(588,400)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,400)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,400)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,380)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,380)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(588,360)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,360)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,360)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(588,340)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,340)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(588,320)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,320)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,320)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,300)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,280)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.6 12 13.2 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(188,260)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(760,160)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(720,160)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(680,160)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,160)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(480,160)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,160)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(440,160)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(420,160)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(400,160)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,160)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(360,160)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(200,160)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(160,160)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(120,160)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.96 20 7.92 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(80,160)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C11.47660743 6.21705504 9.98716802 11.30837584 7.625 17.0625 C7.32078125 17.82626953 7.0165625 18.59003906 6.703125 19.37695312 C4.87280775 23.94883532 2.95649451 28.48085778 1 33 C0.67 33 0.34 33 0 33 C0 22.11 0 11.22 0 0 Z ",
    fill: "#FBFBFB",
    transform: "translate(240,120)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 6.27 12 12.54 12 19 C8.04 19 4.08 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(188,241)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 0.66 16 1.32 16 2 C16.66 2 17.32 2 18 2 C20.32221873 5.77360544 20 7.01199411 20 12 C13.4 12 6.8 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FCFCFC",
    transform: "translate(520,160)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0.495 6.93 0.495 14 1 C14 7.6 14 14.2 14 21 C12.02 21 10.04 21 8 21 C5.03584181 14.0758202 2.27435204 7.18216433 0 0 Z ",
    fill: "#E8E8E8",
    transform: "translate(586,119)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.52408421 2.52408421 3.16305643 4.83342688 4.375 8.1875 C6.21968261 13.13584742 8.29208159 17.48680265 11 22 C11 22.66 11 23.32 11 24 C6.38 24 1.76 24 -3 24 C-3 17.4 -3 10.8 -3 4 C-2.01 4 -1.02 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#E3E3E3",
    transform: "translate(123,776)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.61 0 11.22 0 17 0 C17 3.96 17 7.92 17 12 C14.89758397 12.13496251 12.7927039 12.23197307 10.6875 12.3125 C9.51574219 12.37050781 8.34398437 12.42851562 7.13671875 12.48828125 C4 12 4 12 2.14453125 9.91796875 C1 7 1 7 0 0 Z ",
    fill: "#FBFBFB",
    transform: "translate(603,160)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94 0 11.88 0 18 0 C18 6.6 18 13.2 18 20 C16.02 20 14.04 20 12 20 C11.89042969 19.33613281 11.78085937 18.67226563 11.66796875 17.98828125 C10.5243124 10.99566988 10.5243124 10.99566988 7 5 C4.7271954 3.46281296 2.45520654 2.25076559 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#E9E9E9",
    transform: "translate(442,300)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.80802546 0.55575718 11.14356983 2.58302062 16.4375 7.0625 C18 9 18 9 18 12 C12.06 12 6.12 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FAFAFA",
    transform: "translate(500,108)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C1.38 20 -3.24 20 -8 20 C-2.125 12.125 -2.125 12.125 -1 11 C-0.76636119 9.15108054 -0.58696365 7.29511969 -0.4375 5.4375 C-0.35371094 4.42558594 -0.26992188 3.41367187 -0.18359375 2.37109375 C-0.12300781 1.58863281 -0.06242187 0.80617188 0 0 Z ",
    fill: "#E9E9E9",
    transform: "translate(454,700)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.01417969 0.71285156 6.02835937 1.42570313 6.04296875 2.16015625 C6.39013015 9.13153242 7.55764353 12.64639092 12 18 C12 18.66 12 19.32 12 20 C8.04 20 4.08 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FAFAFA",
    transform: "translate(380,700)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,680)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,680)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,660)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,660)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,640)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,640)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,620)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,620)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,600)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,600)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,580)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,580)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,560)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,560)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,540)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,540)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,520)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,520)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,500)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,500)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,480)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,480)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,460)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,460)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,440)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,440)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,420)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,420)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,400)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,400)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(454,380)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,380)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,360)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,360)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,340)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(454,320)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 6.6 6 13.2 6 20 C4.02 20 2.04 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECECEC",
    transform: "translate(380,320)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.6 1 13.2 1 20 C-1.97 20.33 -4.94 20.66 -8 21 C-7.22391195 13.62716355 -4.25344077 6.07634396 0 0 Z ",
    fill: "#DBDBDB",
    transform: "translate(319,120)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C4.57001586 3.56763127 5.69756093 6.99692842 6.6875 11.25 C6.93886719 12.30703125 7.19023438 13.3640625 7.44921875 14.453125 C8 17 8 17 8 18 C5.36 18 2.72 18 0 18 C0 12.06 0 6.12 0 0 Z ",
    fill: "#F3F3F3",
    transform: "translate(520,122)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 6.27 7 12.54 7 19 C2.17145333 14.17145333 -0.4860582 7.8525573 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#F6F6F6",
    transform: "translate(573,80)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0 15.84 0 24 0 C24 0.33 24 0.66 24 1 C23.35675781 1.08636719 22.71351563 1.17273437 22.05078125 1.26171875 C14.23759783 2.47660747 7.28335636 4.96623312 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#E5E5E5",
    transform: "translate(300,40)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.53287116 3.73295272 8.37382288 7.38486548 12 12 C8.04 12 4.08 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#DFDFDF",
    transform: "translate(140,808)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.62 0 9.24 0 14 0 C14 1.98 14 3.96 14 6 C12.54119891 5.85892253 11.08296449 5.71197585 9.625 5.5625 C8.40683594 5.44068359 8.40683594 5.44068359 7.1640625 5.31640625 C5 5 5 5 3 4 C3 3.34 3 2.68 3 2 C2.01 2 1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#F2F2F2",
    transform: "translate(526,40)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C10.2575 0.556875 9.515 1.11375 8.75 1.6875 C6.07458848 3.93727787 4.11324725 6.2309174 2 9 C1.34 9.66 0.68 10.32 0 11 C0 7.37 0 3.74 0 0 Z ",
    fill: "#E3E3E3",
    transform: "translate(520,300)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-7.6 4 -14.2 4 -21 4 C-21 3.67 -21 3.34 -21 3 C-17.87735751 2.30147903 -14.75159876 1.6180743 -11.625 0.9375 C-10.73554687 0.73833984 -9.84609375 0.53917969 -8.9296875 0.33398438 C-8.07890625 0.15029297 -7.228125 -0.03339844 -6.3515625 -0.22265625 C-5.56604004 -0.39547119 -4.78051758 -0.56828613 -3.97119141 -0.74633789 C-2 -1 -2 -1 0 0 Z ",
    fill: "#CFCFCF",
    transform: "translate(661,836)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 5.61 1 11.22 1 17 C-0.32 17 -1.64 17 -3 17 C-3.33 17.66 -3.66 18.32 -4 19 C-3.51349578 14.21604185 -2.87055812 10.44257553 -1 6 C-0.62406934 4.0075675 -0.28020455 2.0081326 0 0 Z ",
    fill: "#D2D2D2",
    transform: "translate(719,763)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C-1.97 9 -4.94 9 -8 9 C-2.25 2.25 -2.25 2.25 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(699,811)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-3.28 6.28 -8.56 11.56 -14 17 C-14.66 16.67 -15.32 16.34 -16 16 C-10.96679794 10.22494276 -5.96260189 4.82082706 0 0 Z ",
    fill: "#2A2A2A",
    transform: "translate(292,52)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.74225629 1.41910652 4.46816835 2.83524899 4.1875 4.25 C4.03667969 5.03890625 3.88585937 5.8278125 3.73046875 6.640625 C3 9 3 9 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#E4E4E4",
    transform: "translate(240,140)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.36179774 1.44077046 5.59156268 3.24750021 8 6 C8 6.66 8 7.32 8 8 C5.36 8 2.72 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#F3F3F3",
    transform: "translate(20,232)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 3.63 5 7.26 5 11 C4.34 11 3.68 11 3 11 C2.49632243 9.54293274 1.99717444 8.08429904 1.5 6.625 C1.2215625 5.81289062 0.943125 5.00078125 0.65625 4.1640625 C0 2 0 2 0 0 Z ",
    fill: "#F5F5F5",
    transform: "translate(595,140)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 2.64 7 5.28 7 8 C5.8274869 7.04882866 4.66212985 6.08882991 3.5 5.125 C2.8503125 4.59132813 2.200625 4.05765625 1.53125 3.5078125 C1.0259375 3.01023437 0.520625 2.51265625 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#DEDEDE",
    transform: "translate(193,760)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.39750048 3.15835107 -3.05198234 5.32272825 -5.5 7.75 C-6.41265625 8.67039062 -6.41265625 8.67039062 -7.34375 9.609375 C-9 11 -9 11 -11 11 C-9.60249952 7.84164893 -7.94801766 5.67727175 -5.5 3.25 C-4.8915625 2.63640625 -4.283125 2.0228125 -3.65625 1.390625 C-2 0 -2 0 0 0 Z ",
    fill: "#D7D7D7",
    transform: "translate(700,809)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.09902323 3.09902323 2.9898579 5.39147385 3.0625 9.75 C3.041875 10.8225 3.02125 11.895 3 13 C2.01 13 1.02 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#F6F6F6",
    transform: "translate(120,767)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.38672669 2.96283313 4.7353371 5.94270509 7 9 C4.69 9 2.38 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#D7D7D7",
    transform: "translate(520,711)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.4391134 0.28359887 2.87625518 0.57721399 4.3125 0.875 C5.11300781 1.03742187 5.91351563 1.19984375 6.73828125 1.3671875 C9 2 9 2 12 4 C8.04 4 4.08 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#F8F8F8",
    transform: "translate(180,836)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C5.42655063 2.86724686 5.1385485 3.8614515 3 6 C2.01 6 1.02 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#F6F6F6",
    transform: "translate(640,760)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.47676838 2.70168747 1.42826678 4.38427638 -0.16015625 6.66796875 C-2.6896113 9.39149963 -4.1090643 10.883791 -7.875 11.375 C-8.57625 11.25125 -9.2775 11.1275 -10 11 C-5.25 7 -5.25 7 -3 7 C-2.690625 6.21625 -2.38125 5.4325 -2.0625 4.625 C-1 2 -1 2 0 0 Z ",
    fill: "#C9C9C9",
    transform: "translate(819,229)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.51789063 1.47050781 1.03578125 1.94101562 0.5390625 2.42578125 C-0.40839844 3.35970703 -0.40839844 3.35970703 -1.375 4.3125 C-2.00148438 4.92738281 -2.62796875 5.54226563 -3.2734375 6.17578125 C-5.18086607 8.08812528 -5.18086607 8.08812528 -7 11 C-6.49697411 6.59852343 -4.97554199 4.24604581 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#252525",
    transform: "translate(261,302)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C-0.98 6 -2.96 6 -5 6 C-3.35830472 3.97945196 -1.69088222 1.97956942 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(819,234)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.31 3.31 -2.62 5.62 -5 8 C-5 5 -5 5 -2.5 2.3125 C-1.675 1.549375 -0.85 0.78625 0 0 Z ",
    fill: "#272727",
    transform: "translate(394,302)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.df21661a7f76ac29e606cd2b6aa0a493.svg";
export { ForwardRef as ReactComponent };